// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Design Tokens ───────────────────────────────────────────── */
:root {
    --bg:            #FAF6F0;
    --surface:       #F2E8DA;
    --surface-alt:   #EAD9C4;
    --brown-dark:    #4A2512;
    --brown:         #7B4A2D;
    --brown-light:   #B8855A;
    --pink:          #E0849A;
    --pink-light:    #E8B4C0;
    --pink-dark:     #A85C72;
    --black:         #1A0F0A;
    --text-muted:    #7A6055;
    --border:        #D4B896;
    --border-focus:  #C4768A;
    --shadow-sm:     0 1px 3px rgba(74, 37, 18, 0.08);
    --shadow-md:     0 4px 16px rgba(74, 37, 18, 0.12);
    --shadow-lg:     0 8px 32px rgba(74, 37, 18, 0.16);
    --radius-sm:     6px;
    --radius-md:     12px;
    --radius-lg:     20px;
    --font-serif:    'Playfair Display', Georgia, serif;
    --font-sans:     'Lato', system-ui, sans-serif;
    --font-script:   'Dancing Script', cursive;
}

/* ── Reset & Base ────────────────────────────────────────────── */
*, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
}

html {
    scroll-behavior: smooth;
    scrollbar-gutter: stable;
}

html,
body,
#root {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
}

body {
    font-family: var(--font-sans);
    background-color: var(--bg);
    color: var(--black);
    line-height: 1.6;
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
}

img, iframe, input, textarea, select, button {
    max-width: 100%;
}

/* ── Header ──────────────────────────────────────────────────── */
.header {
    background: linear-gradient(160deg, #3a1a0a 0%, var(--brown-dark) 60%, #5a2e14 100%);
    border-bottom: 1px solid rgba(196, 118, 138, 0.25);
    padding: 0 2.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 80px;
    box-shadow: 0 4px 24px rgba(30, 10, 4, 0.35), 0 1px 0 rgba(196, 118, 138, 0.15);
    position: sticky;
    top: 0;
    z-index: 100;
}

.header-brand {
    font-family: var(--font-script);
    font-size: 2.1rem;
    font-weight: 700;
    color: #fff;
    letter-spacing: 0.02em;
    text-decoration: none;
    text-shadow: 0 2px 12px rgba(0, 0, 0, 0.5), 0 1px 0 rgba(255, 255, 255, 0.08);
}

.header-brand span {
    font-size: 1.65rem;
    color: var(--pink-light);
    text-shadow: 0 0 24px rgba(232, 180, 192, 0.7), 0 2px 8px rgba(0, 0, 0, 0.3);
}

.header-nav {
    display: flex;
    align-items: center;
    gap: 2rem;
}

.header-nav-link {
    font-family: var(--font-sans);
    font-size: 0.78rem;
    font-weight: 600;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--surface-alt);
    text-decoration: none;
    opacity: 0.8;
    transition: color 0.15s, opacity 0.15s, text-shadow 0.15s;
}

.header-nav-link:hover {
    color: var(--pink-light);
    opacity: 1;
    text-shadow: 0 0 12px rgba(232, 180, 192, 0.5);
}

.header-nav-cta {
    padding: 0.55rem 1.35rem;
    background: var(--pink);
    color: #fff;
    border-radius: var(--radius-lg);
    font-family: var(--font-sans);
    font-size: 0.8rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    text-decoration: none;
    transition: background 0.15s, transform 0.1s, box-shadow 0.15s;
    box-shadow: 0 2px 8px rgba(168, 92, 114, 0.3);
}

.header-nav-cta:hover {
    background: var(--pink-dark);
    transform: translateY(-1px);
    box-shadow: 0 4px 14px rgba(168, 92, 114, 0.4);
}

.header-hamburger {
    display: none;
    flex-direction: column;
    justify-content: center;
    gap: 5px;
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    margin-left: 0.25rem;
}

.header-hamburger span {
    display: block;
    width: 22px;
    height: 2px;
    background: rgba(255, 255, 255, 0.85);
    border-radius: 2px;
    transition: transform 0.2s ease, opacity 0.2s ease;
}

.header-hamburger.is-open span:nth-child(1) {
    transform: translateY(7px) rotate(45deg);
}

.header-hamburger.is-open span:nth-child(2) {
    opacity: 0;
}

.header-hamburger.is-open span:nth-child(3) {
    transform: translateY(-7px) rotate(-45deg);
}

.header-mobile-menu {
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    background: linear-gradient(160deg, #3a1a0a 0%, var(--brown-dark) 60%, #5a2e14 100%);
    border-bottom: 1px solid rgba(196, 118, 138, 0.25);
    box-shadow: 0 8px 24px rgba(30, 10, 4, 0.4);
    z-index: 99;
    display: flex;
    flex-direction: column;
}

.header-mobile-menu-link {
    padding: 1rem 1.5rem;
    font-family: var(--font-sans);
    font-size: 0.78rem;
    font-weight: 600;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    border-bottom: 1px solid rgba(196, 118, 138, 0.12);
    transition: color 0.15s, background 0.15s;
}

.header-mobile-menu-link:last-child {
    border-bottom: none;
}

.header-mobile-menu-link:hover {
    color: var(--pink-light);
    background: rgba(196, 118, 138, 0.08);
}

/* ── Hero ────────────────────────────────────────────────────── */
@keyframes heroFadeUp {
    from { opacity: 0; transform: translateY(28px); }
    to   { opacity: 1; transform: translateY(0);    }
}

.hero {
    position: relative;
    min-height: 85vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    background: linear-gradient(150deg, var(--surface) 0%, var(--bg) 55%, var(--surface-alt) 100%);
    padding: 6rem 2rem 7rem;
    overflow: hidden;
}

/* Scattered confetti / sprinkle dots */
.hero::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image:
        radial-gradient(circle, rgba(196,118,138,0.50) 3px,   transparent 3px),
        radial-gradient(circle, rgba(184,133,90,0.38)  2px,   transparent 2px),
        radial-gradient(circle, rgba(74,37,18,0.12)    2.5px, transparent 2.5px),
        radial-gradient(circle, rgba(232,180,192,0.55) 2px,   transparent 2px),
        radial-gradient(circle, rgba(196,118,138,0.22) 1.5px, transparent 1.5px);
    background-size:
        82px 82px,
        58px 58px,
        108px 108px,
        68px 68px,
        46px 46px;
    background-position:
        8px 18px,
        36px 48px,
        62px 14px,
        22px 68px,
        52px 36px;
    transform: translateY(var(--dot-parallax, 0px));
    will-change: transform;
    pointer-events: none;
    z-index: 0;
}

/* Soft pink glow blob — top right */
.hero::after {
    content: '';
    position: absolute;
    width: 640px;
    height: 640px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(196,118,138,0.13) 0%, transparent 68%);
    top: -220px;
    right: -180px;
    pointer-events: none;
    z-index: 0;
}

.hero-inner {
    position: relative;
    z-index: 1;
    max-width: 720px;
    opacity: 0;
}

.hero-inner--ready {
    animation: heroFadeUp 0.85s ease-out both;
}

/* Second glow blob — bottom left */
.hero-blob {
    position: absolute;
    width: 500px;
    height: 500px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(184,133,90,0.1) 0%, transparent 70%);
    bottom: -180px;
    left: -140px;
    pointer-events: none;
    z-index: 0;
}

.hero-eyebrow {
    display: block;
    font-family: var(--font-script);
    font-size: clamp(1.5rem, 3.5vw, 2.2rem);
    color: var(--brown);
    margin-bottom: 0.6rem;
    opacity: 0.9;
}

.hero-logo {
    display: block;
    max-width: clamp(260px, 50vw, 480px);
    height: auto;
    margin: 0 auto 1rem;
}

.hero-title {
    font-family: var(--font-serif);
    font-size: clamp(2.8rem, 8vw, 5.5rem);
    font-weight: 600;
    color: var(--brown-dark);
    line-height: 1.08;
    margin-bottom: 1.5rem;
    letter-spacing: -0.01em;
}

.hero-title em {
    font-style: italic;
    color: rgb(254, 137, 153);
}

.hero-title-by {
    display: block;
    font-size: 0.38em;
    font-weight: 400;
    font-style: italic;
    color: var(--brown);
    letter-spacing: 0.04em;
    margin-top: 0.5em;
    opacity: 0.85;
}

.hero-divider {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.6rem;
    margin: 0 auto 1.5rem;
    width: 160px;
}

.hero-divider::before,
.hero-divider::after {
    content: '';
    flex: 1;
    height: 1px;
    background: var(--brown-light);
    opacity: 0.45;
}

.hero-divider-dot {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: var(--pink);
    opacity: 0.65;
    display: inline-block;
}

.hero-subtitle {
    font-size: clamp(1rem, 2vw, 1.15rem);
    color: var(--text-muted);
    font-weight: 400;
    max-width: 460px;
    margin: 0 auto 2.75rem;
    line-height: 1.75;
    letter-spacing: 0.01em;
}

.hero-cta {
    display: inline-block;
    padding: 1rem 2.75rem;
    background: var(--brown-dark);
    color: var(--bg);
    font-family: var(--font-sans);
    font-size: 0.82rem;
    font-weight: 700;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    text-decoration: none;
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-md);
    transition: background 0.2s, transform 0.15s, box-shadow 0.2s;
}

.hero-cta:hover {
    background: var(--brown);
    transform: translateY(-2px);
    box-shadow: var(--shadow-lg);
}

/* ── Process Strip ───────────────────────────────────────────── */
.process-strip {
    background: var(--brown-dark);
    padding: 4rem 2rem;
}

.process-strip-inner {
    max-width: 880px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr auto 1fr auto 1fr;
    align-items: center;
    gap: 1rem;
}

.process-step {
    text-align: center;
    padding: 0 1rem;
}

.process-step-num {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: rgba(196, 118, 138, 0.18);
    border: 1.5px solid rgba(232, 180, 192, 0.5);
    color: var(--pink-light);
    font-family: var(--font-serif);
    font-size: 1.15rem;
    font-weight: 600;
    margin: 0 auto 1rem;
}

.process-step-title {
    font-family: var(--font-serif);
    font-size: 1.05rem;
    color: var(--bg);
    margin-bottom: 0.4rem;
    letter-spacing: 0.01em;
}

.process-step-desc {
    font-size: 0.82rem;
    color: var(--surface-alt);
    line-height: 1.6;
    opacity: 0.8;
}

.process-arrow {
    color: rgba(232, 180, 192, 0.35);
    font-size: 1.4rem;
    letter-spacing: 0.2em;
    text-align: center;
    user-select: none;
}

/* ── Page Layout ─────────────────────────────────────────────── */
#order {
    scroll-margin-top: 96px;
}

.page-content {
    max-width: 1100px;
    margin: 0 auto;
    padding: 3rem 2rem 4rem;
}

.order-section {
    display: flex;
    gap: 2.5rem;
    align-items: flex-start;
}

.order-section-form {
    flex: 1;
    min-width: 0;
}

.order-section-map {
    flex: 1;
    min-width: 0;
    position: sticky;
    top: 90px;
}

.order-section-map-label {
    font-family: var(--font-serif);
    font-size: 1.15rem;
    color: var(--brown-dark);
    margin-bottom: 0.75rem;
    font-style: italic;
}

/* ── Section Heading ─────────────────────────────────────────── */
.section-heading {
    font-family: var(--font-serif);
    font-size: 1.5rem;
    color: var(--brown-dark);
    margin-bottom: 1.5rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid var(--surface-alt);
}

/* ── Order Delivery / Policy Notices ────────────────────────── */
.order-delivery-notice {
    font-size: 0.85rem;
    color: var(--pink-dark);
    font-weight: 600;
    margin-bottom: 0.5rem;
}

.order-policy-notice {
    font-size: 0.78rem;
    color: var(--text-muted);
    margin-bottom: 1.25rem;
    line-height: 1.5;
}

.order-policy-link {
    color: var(--pink-dark);
    text-decoration: underline;
    text-underline-offset: 2px;
    transition: color 0.15s;
}

.order-policy-link:hover {
    color: var(--pink);
}

/* ── Form Card ───────────────────────────────────────────────── */
.form-card {
    background: #fff;
    border: 1px solid var(--border);
    border-radius: var(--radius-md);
    padding: 2rem;
    box-shadow: var(--shadow-md);
}

.form-field {
    margin-bottom: 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
}

.form-label {
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--brown);
}

.form-input,
.form-textarea {
    width: 100%;
    padding: 0.65rem 0.85rem;
    border: 1.5px solid var(--border);
    border-radius: var(--radius-sm);
    background: var(--bg);
    color: var(--black);
    font-family: var(--font-sans);
    font-size: 0.95rem;
    transition: border-color 0.15s, box-shadow 0.15s;
    outline: none;
}

.form-input:focus,
.form-textarea:focus {
    border-color: var(--border-focus);
    box-shadow: 0 0 0 3px rgba(196, 118, 138, 0.18);
}

.form-textarea {
    resize: vertical;
    min-height: 110px;
}

/* ── Radio Group ─────────────────────────────────────────────── */
.form-radio-group {
    display: flex;
    gap: 0.75rem;
}

.form-radio-option {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.55rem 1.1rem;
    border: 1.5px solid var(--border);
    border-radius: var(--radius-lg);
    cursor: pointer;
    font-size: 0.9rem;
    color: var(--text-muted);
    transition: border-color 0.15s, background 0.15s, color 0.15s;
    user-select: none;
}

.form-radio-option input[type="radio"] {
    display: none;
}

.form-radio-option.selected {
    border-color: var(--pink);
    background: var(--pink-light);
    color: var(--brown-dark);
    font-weight: 700;
}

/* ── File Input ──────────────────────────────────────────────── */
input[type="file"].form-input {
    padding: 0.45rem 0.6rem;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.form-file-hint {
    font-size: 0.78rem;
    color: var(--text-muted);
    margin-top: 0.2rem;
}

/* ── SMS Consent ─────────────────────────────────────────────── */
.sms-consent {
    background: var(--bg);
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    padding: 0.9rem 1rem;
    margin-bottom: 1.15rem;
}

.sms-consent-row {
    display: flex;
    gap: 0.65rem;
    align-items: flex-start;
    cursor: pointer;
}

.sms-consent-row input[type="checkbox"] {
    margin-top: 3px;
    flex-shrink: 0;
    accent-color: var(--pink);
    width: 15px;
    height: 15px;
    cursor: pointer;
}

.consent-text {
    font-size: 0.82rem;
    color: var(--brown);
    line-height: 1.65;
}

.rates-note {
    font-size: 0.77rem;
    color: var(--text-muted);
    margin-top: 0.45rem;
    padding-left: 1.65rem;
    line-height: 1.55;
}

.rates-note a {
    color: var(--pink);
}

/* ── Submit Button ───────────────────────────────────────────── */
.form-submit {
    width: 100%;
    margin-top: 0.5rem;
    padding: 0.8rem 1.5rem;
    background: var(--pink);
    color: #fff;
    font-family: var(--font-sans);
    font-size: 0.9rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    border: none;
    border-radius: var(--radius-sm);
    cursor: pointer;
    transition: background 0.15s, transform 0.1s, box-shadow 0.15s;
    box-shadow: var(--shadow-sm);
}

.form-submit:hover:not(:disabled) {
    background: var(--pink-dark);
    box-shadow: var(--shadow-md);
    transform: translateY(-1px);
}

.form-submit:active:not(:disabled) {
    transform: translateY(0);
}

.form-submit:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* ── Form States ─────────────────────────────────────────────── */
@keyframes shake {
    0%, 100% { transform: translateX(0); }
    15%       { transform: translateX(-6px); }
    30%       { transform: translateX(6px); }
    45%       { transform: translateX(-4px); }
    60%       { transform: translateX(4px); }
    75%       { transform: translateX(-2px); }
    90%       { transform: translateX(2px); }
}

.form-error {
    background: #fdf2f4;
    border: 1px solid #f0b8c2;
    border-radius: var(--radius-sm);
    color: #9b3a50;
    font-size: 0.875rem;
    padding: 0.65rem 0.9rem;
    margin-top: 1rem;
    animation: shake 0.5s ease-in-out;
}

.form-success {
    text-align: center;
    padding: 2.5rem 1rem;
}

.form-success-title {
    font-family: var(--font-serif);
    font-size: 1.6rem;
    color: var(--brown-dark);
    margin-bottom: 0.5rem;
}

.form-success-text {
    color: var(--text-muted);
    font-size: 0.95rem;
}

/* ── Footer ──────────────────────────────────────────────────── */
.footer {
    background: var(--brown-dark);
    padding: 3.5rem 2.5rem 0;
    margin-top: 0;
}

.footer-inner {
    max-width: 1100px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 3rem;
    padding-bottom: 2.5rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.footer-brand-name {
    font-family: var(--font-serif);
    font-size: 1.6rem;
    font-weight: 600;
    color: var(--bg);
    letter-spacing: 0.04em;
    margin-bottom: 0.4rem;
}

.footer-brand-name span {
    color: var(--pink-light);
}

.footer-tagline {
    display: block;
    font-family: var(--font-script);
    font-size: 1.15rem;
    color: var(--pink-light);
    opacity: 0.75;
}

.footer-col-title {
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--surface-alt);
    opacity: 0.5;
    margin-bottom: 1rem;
}

.footer-contact {
    font-size: 0.88rem;
    color: var(--surface-alt);
    margin-bottom: 1rem;
    line-height: 1.6;
}

.footer-contact a {
    color: var(--pink-light);
    text-decoration: none;
    transition: opacity 0.15s;
}

.footer-contact a:hover {
    opacity: 0.75;
}

.footer-links {
    display: flex;
    gap: 1.5rem;
    flex-wrap: wrap;
}

.footer-links a {
    color: var(--surface-alt);
    font-size: 0.78rem;
    letter-spacing: 0.06em;
    text-decoration: none;
    text-transform: uppercase;
    opacity: 0.65;
    transition: color 0.15s, opacity 0.15s;
}

.footer-links a:hover {
    color: var(--pink-light);
    opacity: 1;
}

.footer-bottom {
    max-width: 1100px;
    margin: 0 auto;
    padding: 1.25rem 0 1.5rem;
    display: flex;
    justify-content: center;
}

.footer-copy {
    font-size: 0.72rem;
    color: var(--surface-alt);
    opacity: 0.4;
    letter-spacing: 0.03em;
}

/* ── Status Pages (payment success / cancel) ─────────────────── */
.status-page {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background: var(--bg);
}

.status-body {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem 1rem;
}

.status-card {
    background: #fff;
    border: 1px solid var(--border);
    border-radius: var(--radius-md);
    padding: 3rem 2.5rem;
    text-align: center;
    max-width: 460px;
    width: 100%;
    box-shadow: var(--shadow-md);
}

.status-icon {
    font-size: 2.75rem;
    margin-bottom: 1rem;
    display: block;
}

.status-title {
    font-family: var(--font-serif);
    font-size: 1.75rem;
    color: var(--brown-dark);
    margin-bottom: 0.75rem;
}

.status-text {
    color: var(--text-muted);
    font-size: 0.95rem;
    line-height: 1.6;
}

.status-countdown {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: var(--surface-alt);
    color: var(--brown);
    font-weight: 700;
    border-radius: 50%;
    width: 1.75rem;
    height: 1.75rem;
    font-size: 0.85rem;
    vertical-align: middle;
}

/* ── Policy / Legal Pages ─────────────────────────────────────── */
.policy-page {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background: var(--bg);
}

.policy-content {
    flex: 1;
    max-width: 760px;
    margin: 0 auto;
    padding: 3rem 2rem 4rem;
    width: 100%;
}

.policy-title {
    font-family: var(--font-serif);
    font-size: 2rem;
    color: var(--brown-dark);
    margin-bottom: 0.35rem;
}

.policy-meta {
    color: var(--text-muted);
    font-size: 0.83rem;
    margin-bottom: 1.5rem;
}

.policy-summary {
    background: var(--surface);
    border-left: 3px solid var(--pink);
    border-radius: 0 var(--radius-sm) var(--radius-sm) 0;
    padding: 0.9rem 1.2rem;
    font-size: 0.88rem;
    color: var(--brown);
    margin-bottom: 2.5rem;
    line-height: 1.65;
}

.policy-section {
    margin-bottom: 2rem;
}

.policy-section h2 {
    font-family: var(--font-serif);
    font-size: 1.1rem;
    color: var(--brown-dark);
    margin-bottom: 0.55rem;
    padding-bottom: 0.35rem;
    border-bottom: 1px solid var(--border);
}

.policy-section p {
    color: var(--black);
    font-size: 0.9rem;
    line-height: 1.75;
    margin-bottom: 0.65rem;
}

.policy-section ul {
    padding-left: 1.25rem;
    margin-bottom: 0.65rem;
}

.policy-section li {
    color: var(--black);
    font-size: 0.9rem;
    line-height: 1.75;
    margin-bottom: 0.25rem;
}

.policy-section a {
    color: var(--pink-dark);
    text-decoration: underline;
}

.policy-footer {
    text-align: center;
    padding: 1.25rem 2rem;
    color: var(--text-muted);
    font-size: 0.78rem;
    border-top: 1px solid var(--border);
    margin-top: 1.5rem;
}

/* ── Admin Dashboard ─────────────────────────────────────────── */
.admin-page {
    min-height: 100vh;
    background: var(--surface);
    font-family: var(--font-sans);
}

.admin-topbar {
    background: var(--brown-dark);
    padding: 0.75rem 2rem;
    min-height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    flex-wrap: wrap;
    box-shadow: var(--shadow-md);
    position: sticky;
    top: 0;
    z-index: 100;
}

.admin-topbar-brand {
    font-family: var(--font-serif);
    font-size: 1.2rem;
    color: var(--bg);
    letter-spacing: 0.03em;
}

.admin-topbar-brand span {
    color: var(--pink-light);
}

.admin-topbar-right {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.admin-user-email {
    font-size: 0.78rem;
    color: var(--surface-alt);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 180px;
}

.admin-logout-btn {
    padding: 0.3rem 0.75rem;
    background: transparent;
    color: var(--surface-alt);
    border: 1px solid rgba(255,255,255,0.2);
    border-radius: var(--radius-sm);
    cursor: pointer;
    font-size: 0.78rem;
    font-family: var(--font-sans);
    transition: background 0.15s, color 0.15s;
}

.admin-logout-btn:hover {
    background: rgba(255,255,255,0.1);
    color: #fff;
}

.admin-body {
    padding: 2rem;
    max-width: 1400px;
    margin: 0 auto;
}

.admin-status-msg {
    color: var(--text-muted);
    font-size: 0.9rem;
    padding: 0.5rem 0;
}

.admin-error {
    color: #9b3a50;
    font-size: 0.875rem;
}

.admin-section-nav {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    margin-bottom: 1rem;
    background: var(--surface);
    border-bottom: 1px solid var(--border);
    position: sticky;
    top: 0;
    z-index: 10;
}

.admin-section-nav-btn {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.35rem 0.85rem;
    background: var(--bg);
    border: 1px solid var(--border);
    border-radius: 999px;
    font-size: 0.8rem;
    font-weight: 500;
    color: var(--text);
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s;
}

.admin-section-nav-btn:hover {
    background: var(--pink-light);
    border-color: var(--pink);
}

.admin-board {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
}

.admin-column {
    background: #fff;
    border: 1px solid var(--border);
    border-radius: var(--radius-md);
    padding: 1.25rem;
    box-shadow: var(--shadow-sm);
}

.admin-column-header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 1rem;
    font-family: var(--font-serif);
    font-size: 1rem;
    color: var(--brown-dark);
}

.admin-badge {
    background: var(--surface-alt);
    color: var(--brown);
    border-radius: 12px;
    padding: 0.1rem 0.55rem;
    font-size: 0.72rem;
    font-weight: 700;
    font-family: var(--font-sans);
}

.admin-login-page {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: var(--bg);
    gap: 1.25rem;
}

.admin-login-title {
    font-family: var(--font-serif);
    font-size: 1.5rem;
    color: var(--brown-dark);
}

.admin-login-btn {
    padding: 0.7rem 1.75rem;
    background: var(--brown-dark);
    color: var(--bg);
    border: none;
    border-radius: var(--radius-sm);
    cursor: pointer;
    font-family: var(--font-sans);
    font-size: 0.88rem;
    font-weight: 700;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    transition: background 0.15s;
}

.admin-login-btn:hover {
    background: var(--brown);
}

/* ── Order Card (admin) ──────────────────────────────────────── */
.order-card {
    background: var(--bg);
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    padding: 1rem;
    margin-bottom: 0.75rem;
    color: var(--black);
}

.order-card-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
}

.order-card-id {
    font-family: var(--font-serif);
    font-size: 0.95rem;
    color: var(--brown-dark);
    font-weight: 600;
}

.order-card-meta {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.order-card-date {
    color: var(--text-muted);
    font-size: 0.78rem;
}

.order-card-field {
    font-size: 0.855rem;
    color: var(--black);
    margin: 0.2rem 0;
}

.order-card-field a {
    color: var(--pink-dark);
    text-decoration: underline;
}

.sms-status {
    font-size: 1rem;
    font-weight: 700;
    margin: 0.4rem 0 0.6rem;
}

.sms-status--automatic {
    color: #2d6a4f;
}

.sms-status--manual {
    color: #9b2c2c;
}

.order-card-comments-edit {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
}

.order-card-comments-view {
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
}

.order-card-comments-text {
    font-size: 0.855rem;
    color: var(--black);
    flex: 1;
    margin: 0.2rem 0;
}

.order-card-comments-label {
    display: block;
    font-weight: 600;
    margin-bottom: 0.2rem;
}

.order-card-comments-body {
    margin: 0;
    white-space: pre-wrap;
}

.order-card-comments-none {
    color: var(--text-muted);
    font-style: italic;
}

.order-card-comments-actions {
    display: flex;
    gap: 0.4rem;
}

.order-card-textarea {
    width: 100%;
    padding: 0.4rem 0.6rem;
    border: 1.5px solid var(--border);
    border-radius: var(--radius-sm);
    background: #fff;
    color: var(--black);
    font-family: var(--font-sans);
    font-size: 0.855rem;
    resize: vertical;
    min-height: 60px;
    outline: none;
}

.order-card-textarea:focus {
    border-color: var(--border-focus);
}

.order-card-photos {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    margin-top: 0.75rem;
}

.order-card-thumbnail {
    width: 80px;
    height: 80px;
    object-fit: cover;
    border-radius: var(--radius-sm);
    display: block;
    border: 1px solid var(--border);
}

.order-card-actions {
    margin-top: 0.75rem;
    display: flex;
    gap: 0.5rem;
    align-items: center;
    flex-wrap: wrap;
}

.order-card-input {
    padding: 0.38rem 0.6rem;
    border: 1.5px solid var(--border);
    border-radius: var(--radius-sm);
    background: #fff;
    color: var(--black);
    font-family: var(--font-sans);
    font-size: 0.855rem;
    width: 180px;
    outline: none;
    max-width: 100%;
}

.order-card-input:focus {
    border-color: var(--border-focus);
}

.order-card-waiting {
    color: var(--text-muted);
    font-style: italic;
    font-size: 0.83rem;
    margin: 0;
}

.order-card-urgent-notice {
    background: #fdf2f4;
    border: 1px solid #f0b8c2;
    border-radius: var(--radius-sm);
    color: #9b3a50;
    font-size: 0.83rem;
    font-weight: 600;
    padding: 0.55rem 0.8rem;
    margin: 0;
}

.order-card-url-box {
    margin-top: 0.75rem;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: var(--surface);
    padding: 0.5rem 0.75rem;
    border-radius: var(--radius-sm);
    border: 1px solid var(--border);
}

.order-card-url-text {
    font-size: 0.78rem;
    word-break: break-all;
    flex: 1;
    color: var(--brown);
}

.order-card-refund-section {
    margin-top: 1rem;
    border-top: 1px solid var(--border);
    padding-top: 0.75rem;
    display: flex;
    gap: 0.5rem;
    align-items: center;
    flex-wrap: wrap;
}

.order-card-refund-label {
    font-size: 0.8rem;
    color: var(--text-muted);
}

.order-card-error {
    color: #9b3a50;
    font-size: 0.83rem;
    margin-top: 0.5rem;
}

.btn-accept  { padding: 0.38rem 0.85rem; background: #16a34a; color: #fff; border: none; border-radius: var(--radius-sm); cursor: pointer; font-size: 0.83rem; font-family: var(--font-sans); }
.btn-reject  { padding: 0.38rem 0.85rem; background: #dc2626; color: #fff; border: none; border-radius: var(--radius-sm); cursor: pointer; font-size: 0.83rem; font-family: var(--font-sans); }
.btn-copy    { padding: 0.32rem 0.65rem; background: var(--brown); color: #fff; border: none; border-radius: var(--radius-sm); cursor: pointer; font-size: 0.78rem; font-family: var(--font-sans); flex-shrink: 0; }
.btn-refund  { padding: 0.38rem 0.85rem; background: #b45309; color: #fff; border: none; border-radius: var(--radius-sm); cursor: pointer; font-size: 0.83rem; font-family: var(--font-sans); }
.btn-icon    { padding: 0.2rem 0.45rem; background: transparent; color: var(--text-muted); border: 1px solid var(--border); border-radius: var(--radius-sm); cursor: pointer; font-size: 0.72rem; line-height: 1; font-family: var(--font-sans); }
.btn-icon:hover { border-color: var(--brown-light); color: var(--brown); }
.btn-accept:disabled, .btn-reject:disabled, .btn-copy:disabled, .btn-refund:disabled { opacity: 0.55; cursor: not-allowed; }

/* ── Options Manager ─────────────────────────────────────────── */
.options-manager {
    margin-bottom: 1.25rem;
}

.options-manager-toggle {
    display: inline-flex;
    align-items: center;
    gap: 0.55rem;
    padding: 0.5rem 1.1rem;
    background: var(--brown-dark);
    color: var(--bg);
    border: none;
    border-radius: var(--radius-sm);
    cursor: pointer;
    font-family: var(--font-sans);
    font-size: 0.8rem;
    font-weight: 700;
    letter-spacing: 0.07em;
    text-transform: uppercase;
    transition: background 0.15s, box-shadow 0.15s;
    box-shadow: var(--shadow-sm);
}

.options-manager-toggle:hover {
    background: var(--brown);
    box-shadow: var(--shadow-md);
}

.options-manager-icon {
    font-size: 0.85rem;
    opacity: 0.8;
}

.options-manager-chevron {
    font-size: 0.75rem;
    display: inline-block;
    transition: transform 0.2s ease;
}

.options-manager-toggle.is-open .options-manager-chevron {
    transform: rotate(180deg);
}

@keyframes omFadeIn {
    from { opacity: 0; }
    to   { opacity: 1; }
}

.options-manager-body {
    margin-top: 0.75rem;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: var(--radius-md);
    padding: 1.25rem;
    box-shadow: var(--shadow-sm);
    animation: omFadeIn 0.15s ease;
}

.options-panel {
    background: #fff;
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.options-panel-title {
    font-family: var(--font-serif);
    font-size: 0.95rem;
    color: var(--brown-dark);
    padding-bottom: 0.5rem;
    border-bottom: 1.5px solid var(--surface-alt);
    margin: 0;
}

.options-list {
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    max-height: 180px;
    overflow-y: auto;
    scrollbar-width: thin;
    scrollbar-color: var(--border) transparent;
    flex: 1;
}

.options-list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.35rem 0.6rem;
    background: var(--bg);
    border-radius: var(--radius-sm);
    font-size: 0.875rem;
    color: var(--black);
    transition: background 0.1s;
}

.options-list-item:hover {
    background: var(--surface-alt);
}

.options-add-row {
    display: flex;
    gap: 0.5rem;
}

.options-add-row .form-input {
    flex: 1;
    font-size: 0.875rem;
    padding: 0.4rem 0.65rem;
}

@media (max-width: 860px) {
    .options-manager-body {
        grid-template-columns: 1fr;
    }
}

.audit-log-body {
    margin-top: 0.75rem;
    animation: omFadeIn 0.15s ease;
}

.audit-log-list {
    max-height: 320px;
}

.audit-log-item {
    justify-content: flex-start;
    gap: 0.65rem;
}

.audit-log-message {
    flex: 1;
}

.audit-log-timestamp {
    color: var(--text-muted);
    font-size: 0.78rem;
    white-space: nowrap;
}

.audit-severity-badge {
    border-radius: 12px;
    padding: 0.1rem 0.55rem;
    font-size: 0.72rem;
    font-weight: 700;
    font-family: var(--font-sans);
    white-space: nowrap;
}

.audit-severity-info {
    background: var(--surface-alt);
    color: var(--brown);
}

.audit-severity-warning {
    background: #fdf0d5;
    color: #9a6b12;
}

.audit-severity-error {
    background: #fbe4e9;
    color: #9b3a50;
}

/* ── Story / Meet the Baker ──────────────────────────────────── */
.story-section {
    background: var(--surface);
    padding: 6rem 2rem;
}

.story-inner {
    max-width: 1100px;
    margin: 0 auto;
    display: flex;
    gap: 5rem;
    align-items: center;
}

.story-content {
    flex: 1;
    min-width: 0;
}

.story-eyebrow {
    display: block;
    font-family: var(--font-script);
    font-size: clamp(1.4rem, 3vw, 2rem);
    color: var(--pink);
    margin-bottom: 0.35rem;
}

.story-heading {
    font-family: var(--font-serif);
    font-size: clamp(2rem, 4vw, 2.75rem);
    font-weight: 600;
    color: var(--brown-dark);
    line-height: 1.12;
    margin-bottom: 1.25rem;
}

.story-rule {
    width: 48px;
    height: 2px;
    background: linear-gradient(90deg, var(--pink), var(--pink-light));
    border-radius: 2px;
    margin-bottom: 1.5rem;
}

.story-body {
    font-size: clamp(0.92rem, 1.8vw, 1.02rem);
    color: var(--text-muted);
    line-height: 1.9;
    margin-bottom: 2rem;
}

.story-tags {
    display: flex;
    gap: 0.6rem;
    flex-wrap: wrap;
}

.story-tag {
    display: inline-block;
    padding: 0.35rem 1rem;
    border: 1.5px solid var(--brown-light);
    border-radius: var(--radius-lg);
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--brown);
}

/* Offset decorative block peeks behind the photo */
.story-photo-wrap {
    flex: 0 0 396px;
    position: relative;
    padding-right: 16px;
    padding-bottom: 16px;
}

.story-photo-wrap::after {
    content: '';
    position: absolute;
    top: 16px;
    right: 0;
    bottom: 0;
    left: 16px;
    background: var(--surface-alt);
    border-radius: var(--radius-lg);
    z-index: 0;
}

.story-photo {
    position: relative;
    z-index: 1;
    width: 100%;
    aspect-ratio: 3 / 4;
    object-fit: cover;
    object-position: top;
    border-radius: var(--radius-lg);
    display: block;
    box-shadow: var(--shadow-lg);
}

/* ── Policies & Booking ──────────────────────────────────────── */
#policies {
    scroll-margin-top: 96px;
}

.policies-section {
    background: var(--bg);
    padding: 6rem 2rem;
}

.policies-inner {
    max-width: 1100px;
    margin: 0 auto;
    display: flex;
    gap: 5rem;
    align-items: center;
}

.policies-photo-wrap {
    flex: 0 0 396px;
    position: relative;
    padding-left: 16px;
    padding-bottom: 16px;
}

.policies-photo-wrap::after {
    content: '';
    position: absolute;
    top: 16px;
    left: 0;
    bottom: 0;
    right: 16px;
    background: var(--surface-alt);
    border-radius: var(--radius-lg);
    z-index: 0;
}

.policies-photo {
    position: relative;
    z-index: 1;
    width: 100%;
    aspect-ratio: 3 / 4;
    object-fit: cover;
    object-position: center;
    border-radius: var(--radius-lg);
    display: block;
    box-shadow: var(--shadow-lg);
}

.policies-content {
    flex: 1;
    min-width: 0;
}

.policies-eyebrow {
    display: block;
    font-family: var(--font-script);
    font-size: clamp(1.4rem, 3vw, 2rem);
    color: var(--pink);
    margin-bottom: 0.35rem;
}

.policies-heading {
    font-family: var(--font-serif);
    font-size: clamp(2rem, 4vw, 2.75rem);
    font-weight: 600;
    color: var(--brown-dark);
    line-height: 1.12;
    margin-bottom: 1.25rem;
}

.policies-rule {
    width: 48px;
    height: 2px;
    background: linear-gradient(90deg, var(--pink), var(--pink-light));
    border-radius: 2px;
    margin-bottom: 1.5rem;
}

.policies-list {
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 1.35rem;
    margin-bottom: 0;
}

.policies-item {
    display: flex;
    flex-direction: column;
    gap: 0.2rem;
    padding-left: 1.5rem;
    position: relative;
}

.policies-item::before {
    content: '✦';
    position: absolute;
    left: 0;
    top: 0.15rem;
    font-size: 0.65rem;
    color: var(--pink);
    line-height: 1.8;
}

.policies-item-label {
    font-family: var(--font-script);
    font-size: clamp(1.15rem, 2.5vw, 1.45rem);
    color: var(--brown-dark);
    line-height: 1.2;
}

.policies-item-text {
    font-size: clamp(0.88rem, 1.7vw, 0.97rem);
    color: var(--text-muted);
    line-height: 1.85;
}

/* ── Gallery Preview Strips ──────────────────────────────────── */
.preview-section {
    padding: 4rem 0 3rem;
    background: var(--bg);
}

.preview-section--alt {
    background: var(--surface);
}

.preview-header {
    max-width: 1100px;
    margin: 0 auto;
    padding: 0 2rem 1.25rem;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 1rem;
}

.preview-eyebrow {
    display: block;
    font-family: var(--font-script);
    font-size: clamp(1.1rem, 2.5vw, 1.5rem);
    color: var(--pink);
    margin-bottom: 0.2rem;
}

.preview-heading {
    font-family: var(--font-serif);
    font-size: clamp(1.6rem, 3vw, 2.2rem);
    font-weight: 600;
    color: var(--brown-dark);
    line-height: 1.1;
    margin: 0;
}

.preview-view-all {
    font-family: var(--font-sans);
    font-size: 0.8rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--brown-light);
    text-decoration: none;
    white-space: nowrap;
    transition: color 0.15s;
    padding-bottom: 0.2rem;
}

.preview-view-all:hover {
    color: var(--pink);
}

/* sidebar will slot in here as a sibling to preview-strip later */
.preview-body {
    position: relative;
    display: flex;
}

/* right-edge fade hints at more content */
.preview-body::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 80px;
    background: linear-gradient(to right, transparent, var(--bg));
    pointer-events: none;
    z-index: 1;
}

.preview-section--alt .preview-body::after {
    background: linear-gradient(to right, transparent, var(--surface));
}

.preview-strip {
    display: flex;
    gap: 1rem;
    overflow-x: auto;
    padding: 0.5rem 2rem 1.5rem;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    flex: 1;
    min-width: 0;
}

.preview-strip::-webkit-scrollbar {
    display: none;
}

.preview-card {
    flex: 0 0 clamp(220px, 70vw, 300px);
    scroll-snap-align: start;
    border-radius: var(--radius-md);
    overflow: hidden;
    box-shadow: 0 8px 28px rgba(74, 37, 18, 0.18), 0 2px 8px rgba(74, 37, 18, 0.10);
    border: 2.5px solid var(--border);
}

.preview-img {
    width: 100%;
    aspect-ratio: 3 / 4;
    object-fit: cover;
    display: block;
    opacity: 0;
    transition: opacity 0.45s ease, transform 0.3s ease;
}

.preview-img.loaded {
    opacity: 1;
}

.preview-card:hover .preview-img {
    transform: scale(1.03);
}

/* ── Cake Gallery ────────────────────────────────────────────── */
.gallery-page {
    opacity: 0;
    transition: opacity 0.55s ease;
}

.gallery-page--ready {
    opacity: 1;
}

.gallery-hero {
    background: var(--surface);
    text-align: center;
    padding: 5rem 2rem 3.5rem;
}

.gallery-eyebrow {
    display: block;
    font-family: var(--font-script);
    font-size: clamp(1.4rem, 3vw, 2rem);
    color: var(--pink);
    margin-bottom: 0.35rem;
}

.gallery-heading {
    font-family: var(--font-serif);
    font-size: clamp(2rem, 5vw, 3.25rem);
    font-weight: 600;
    color: var(--brown-dark);
    line-height: 1.1;
    margin-bottom: 1.25rem;
}

.gallery-rule {
    width: 48px;
    height: 2px;
    background: linear-gradient(90deg, var(--pink), var(--pink-light));
    border-radius: 2px;
    margin: 0 auto 1.25rem;
}

.gallery-subtext {
    font-size: clamp(0.92rem, 1.8vw, 1.02rem);
    color: var(--text-muted);
    max-width: 480px;
    margin: 0 auto;
    line-height: 1.75;
}

.gallery-canvas {
    position: relative;
    background: linear-gradient(160deg, var(--bg) 0%, var(--surface) 50%, var(--bg) 100%);
    overflow: hidden;
}

.gallery-canvas::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image:
        radial-gradient(circle, rgba(196, 118, 138, 0.75) 4px,   transparent 4px),
        radial-gradient(circle, rgba(184, 133, 90,  0.55) 3.5px, transparent 3.5px),
        radial-gradient(circle, rgba(74,  37,  18,  0.20) 3px,   transparent 3px),
        radial-gradient(circle, rgba(232, 180, 192, 0.80) 3px,   transparent 3px),
        radial-gradient(circle, rgba(168, 92,  114, 0.50) 2.5px, transparent 2.5px);
    background-size:
        311px 293px,
        257px 271px,
        383px 367px,
        199px 211px,
        431px 419px;
    background-position:
        10px 20px,
        80px 140px,
        160px 60px,
        40px 180px,
        220px 100px;
    pointer-events: none;
    z-index: 0;
}

.gallery-grid {
    position: relative;
    z-index: 1;
    columns: 3 260px;
    gap: 0.85rem;
    padding: 2.5rem 2rem;
    max-width: 1300px;
    margin: 0 auto;
}

.gallery-item {
    break-inside: avoid;
    margin-bottom: 0.85rem;
    border-radius: var(--radius-md);
    overflow: hidden;
    border: 2.5px solid var(--border);
    box-shadow: 0 8px 28px rgba(74, 37, 18, 0.18), 0 2px 8px rgba(74, 37, 18, 0.10);
}

.gallery-img {
    width: 100%;
    display: block;
    opacity: 0;
    transition: opacity 0.45s ease, transform 0.3s ease, box-shadow 0.3s ease;
}

.gallery-img.loaded {
    opacity: 1;
}

.gallery-item:hover .gallery-img {
    transform: scale(1.025);
    box-shadow: var(--shadow-lg);
}

.bakes-section {
    position: relative;
    z-index: 1;
    max-width: 1300px;
    margin: 0 auto;
    padding-top: 2rem;
}

.bakes-section-header {
    display: flex;
    align-items: center;
    gap: 1.25rem;
    padding: 0 2rem;
    margin-bottom: 0.5rem;
}

.bakes-section-label {
    font-family: var(--font-script);
    font-size: clamp(1.6rem, 3vw, 2.2rem);
    color: var(--brown-dark);
    white-space: nowrap;
}

.bakes-section-rule {
    flex: 1;
    height: 1.5px;
    background: linear-gradient(90deg, var(--brown-light), transparent);
    border-radius: 2px;
    opacity: 0.45;
}

.gallery-cta-wrap {
    position: relative;
    z-index: 1;
    text-align: center;
    padding: 1rem 2rem 5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.25rem;
}

.gallery-cta-text {
    font-family: var(--font-script);
    font-size: clamp(1.4rem, 3vw, 1.9rem);
    color: var(--brown);
}

/* ── Responsive ──────────────────────────────────────────────── */
@media (max-width: 768px) {
    .order-section {
        flex-direction: column;
    }

    .order-section-map {
        position: static;
        width: 100%;
    }

    .hero {
        min-height: 70vh;
        padding: 4rem 1.25rem 5rem;
    }

    .page-content {
        padding: 1.25rem 0.75rem 2rem;
    }

    .form-card {
        padding: 1rem 0.875rem;
        border-radius: var(--radius-sm);
        box-shadow: var(--shadow-sm);
    }

    .form-field {
        margin-bottom: 1rem;
    }

    .header {
        height: 60px;
        padding: 0 1.25rem;
    }

    .header-brand {
        font-size: 1.35rem;
    }

    .header-nav {
        gap: 0.75rem;
    }

    .header-nav-link {
        display: none;
    }

    .header-hamburger {
        display: flex;
    }

    .section-heading {
        font-size: 1.2rem;
        margin-bottom: 1rem;
    }

    .order-section-map-label {
        font-size: 0.95rem;
    }

    .form-radio-group {
        flex-wrap: wrap;
    }

    .form-submit {
        font-size: 0.85rem;
        padding: 0.7rem 1rem;
    }

    .process-strip-inner {
        grid-template-columns: 1fr;
        gap: 2rem;
    }

    .process-arrow {
        display: none;
    }

    .process-step {
        padding: 0;
    }

    .footer-inner {
        grid-template-columns: 1fr;
        gap: 2rem;
    }

    .footer {
        padding: 2.5rem 1.5rem 0;
    }

    .story-section {
        padding: 4rem 1.25rem;
    }

    .story-inner {
        flex-direction: column;
        gap: 2.5rem;
    }

    .story-photo-wrap {
        flex: none;
        width: 100%;
        max-width: 320px;
        margin: 0 auto;
        padding-right: 12px;
        padding-bottom: 12px;
    }

    .story-photo-wrap::after {
        top: 12px;
        left: 12px;
    }

    .policies-section {
        padding: 4rem 1.25rem;
    }

    .policies-inner {
        flex-direction: column-reverse;
        gap: 2.5rem;
    }

    .policies-photo-wrap {
        flex: none;
        width: 100%;
        max-width: 320px;
        margin: 0 auto;
        padding-left: 12px;
        padding-bottom: 12px;
    }

    .policies-photo-wrap::after {
        top: 12px;
        right: 12px;
    }

    .gallery-grid {
        columns: 2 160px;
        padding: 1.5rem 1rem;
    }

    .gallery-hero {
        padding: 3.5rem 1.25rem 2.5rem;
    }
}

@media (min-width: 769px) {
    .preview-strip {
        justify-content: center;
    }
}

/* ── Order Form — item builder & cart ────────────────────────── */
.form-section-label {
    font-family: var(--font-serif);
    font-size: 1.05rem;
    color: var(--brown-dark);
    font-weight: 600;
    margin: 1.5rem 0 0.75rem;
    padding-bottom: 0.4rem;
    border-bottom: 1.5px solid var(--surface-alt);
}

.form-required { color: var(--pink-dark); }

.form-checkbox-row {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.9rem;
    color: var(--brown);
    cursor: pointer;
    margin-bottom: 0.75rem;
}

.form-checkbox-row input[type="checkbox"] {
    accent-color: var(--pink);
    width: 15px;
    height: 15px;
    cursor: pointer;
    flex-shrink: 0;
}

.item-builder {
    background: var(--surface);
    border: 1.5px solid var(--border);
    border-radius: var(--radius-sm);
    padding: 1.25rem;
    margin-bottom: 1rem;
}

.item-builder-note {
    font-size: 0.875rem;
    color: var(--text-muted);
    font-style: italic;
    margin-bottom: 0.75rem;
    line-height: 1.55;
}

.item-builder-price {
    font-size: 0.875rem;
    color: var(--brown);
    font-weight: 600;
    margin-bottom: 0.5rem;
}

.item-builder-actions {
    display: flex;
    gap: 0.5rem;
    margin-top: 0.5rem;
}

.cart-item {
    background: var(--bg);
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    padding: 0.75rem;
    margin-bottom: 0.5rem;
}

.cart-item-header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.35rem;
}

.cart-item-type {
    font-weight: 700;
    font-size: 0.9rem;
    color: var(--brown-dark);
    flex: 1;
}

.cart-item-index {
    font-size: 0.78rem;
    color: var(--text-muted);
}

.cart-item-details {
    list-style: none;
    font-size: 0.83rem;
    color: var(--text-muted);
    line-height: 1.6;
    padding-left: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 0.2rem 0.75rem;
}

.btn-add-item {
    width: 100%;
    padding: 0.6rem;
    background: transparent;
    border: 1.5px dashed var(--border);
    border-radius: var(--radius-sm);
    cursor: pointer;
    font-family: var(--font-sans);
    font-size: 0.88rem;
    font-weight: 600;
    color: var(--brown);
    letter-spacing: 0.04em;
    transition: border-color 0.15s, color 0.15s, background 0.15s;
    margin-bottom: 0.25rem;
}

.btn-add-item:hover {
    border-color: var(--pink);
    color: var(--pink-dark);
    background: rgba(196, 118, 138, 0.04);
}

.fixed-items-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-bottom: 0.75rem;
}

.fixed-item-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    background: var(--bg);
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    padding: 0.65rem 0.85rem;
}

.fixed-item-info {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
    flex: 1;
    min-width: 0;
}

.fixed-item-name { font-weight: 600; font-size: 0.9rem; color: var(--black); }
.fixed-item-meta { font-size: 0.8rem; color: var(--brown); }
.fixed-item-desc { font-size: 0.8rem; color: var(--text-muted); font-style: italic; }

.fixed-item-qty {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    flex-shrink: 0;
}

.qty-btn {
    width: 28px;
    height: 28px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    cursor: pointer;
    font-size: 1rem;
    line-height: 1;
    color: var(--brown);
    font-family: var(--font-sans);
    transition: background 0.1s;
}

.qty-btn:hover { background: var(--surface-alt); }

.qty-value {
    font-size: 0.9rem;
    font-weight: 700;
    color: var(--black);
    min-width: 1.5rem;
    text-align: center;
}

/* ── Order Card — items section ──────────────────────────────── */
.order-card-items {
    margin: 0.5rem 0;
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
}

.order-card-item {
    background: #fff;
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    padding: 0.55rem 0.7rem;
}

.order-card-item-header {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    margin-bottom: 0.25rem;
    flex-wrap: wrap;
}

.order-card-item-type {
    font-weight: 700;
    font-size: 0.855rem;
    color: var(--brown-dark);
}

.order-card-item-size {
    font-size: 0.79rem;
    color: var(--brown);
}

.order-card-item-qty {
    font-size: 0.79rem;
    color: var(--text-muted);
}

.order-card-item-details {
    display: flex;
    flex-wrap: wrap;
    gap: 0.15rem 0.6rem;
    font-size: 0.79rem;
    color: var(--text-muted);
    line-height: 1.5;
}

.order-card-fixed-items {
    border-top: 1px solid var(--border);
    padding-top: 0.35rem;
    margin-top: 0.1rem;
}

.order-card-unit {
    font-weight: normal;
    color: var(--text-muted);
}

.order-card-cake-prices {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin-bottom: 0.5rem;
}

.order-card-cake-price-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
}

.order-card-cake-price-label {
    font-size: 0.85rem;
    font-weight: 600;
    color: var(--brown-dark);
    flex-shrink: 0;
}

.order-card-cake-price-wrap {
    display: flex;
    align-items: center;
    gap: 0.2rem;
}

.order-card-cake-price-symbol {
    font-size: 0.875rem;
    color: var(--text-muted);
}

.order-card-deposit-summary {
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    padding: 0.5rem 0.75rem;
    margin-bottom: 0.5rem;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
}

.order-card-deposit-row {
    display: flex;
    justify-content: space-between;
    font-size: 0.85rem;
    color: var(--brown);
}

.order-card-deposit-row--highlight {
    font-weight: 700;
    color: var(--brown-dark);
    border-top: 1px solid var(--border);
    padding-top: 0.25rem;
    margin-top: 0.1rem;
}

/* ── Options Manager — new panel elements ────────────────────── */
.options-select {
    width: 100%;
    padding: 0.4rem 0.65rem;
    border: 1.5px solid var(--border);
    border-radius: var(--radius-sm);
    background: var(--bg);
    color: var(--black);
    font-family: var(--font-sans);
    font-size: 0.875rem;
    outline: none;
}

.options-select:focus { border-color: var(--border-focus); }

.options-gf-tag {
    font-size: 0.68rem;
    font-weight: 700;
    background: #d1fae5;
    color: #065f46;
    padding: 0.1rem 0.35rem;
    border-radius: 4px;
    letter-spacing: 0.04em;
    flex-shrink: 0;
}

.options-gf-checkbox {
    display: flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.82rem;
    color: var(--brown);
    cursor: pointer;
}

.options-gf-checkbox input[type="checkbox"] {
    accent-color: var(--pink);
    width: 14px;
    height: 14px;
    cursor: pointer;
}

.options-item-meta {
    font-size: 0.78rem;
    color: var(--text-muted);
    flex-shrink: 0;
}

.options-add-form {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
}

.options-add-form .form-input {
    font-size: 0.875rem;
    padding: 0.4rem 0.65rem;
}

/* ── Order Summary (customer form) ───────────────────────────── */
.order-summary {
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    padding: 0.85rem 1rem;
    margin-bottom: 1.25rem;
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
}

.order-summary-row {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    font-size: 0.875rem;
    color: var(--black);
}

.order-summary-total {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    font-size: 0.92rem;
    font-weight: 700;
    color: var(--brown-dark);
    border-top: 1.5px solid var(--border);
    padding-top: 0.4rem;
    margin-top: 0.2rem;
}

.order-summary-tbd {
    font-style: italic;
    font-weight: 400;
    color: var(--text-muted);
    font-size: 0.83rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA,mEAAmE;AACnE;IACI,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,iDAAiD;IACjD,kDAAkD;IAClD,kDAAkD;IAClD,oBAAoB;IACpB,qBAAqB;IACrB,qBAAqB;IACrB,mDAAmD;IACnD,8CAA8C;IAC9C,0CAA0C;AAC9C;;AAEA,mEAAmE;AACnE;IACI,sBAAsB;IACtB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;;;IAGI,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,mCAAmC;AACvC;;AAEA;IACI,eAAe;AACnB;;AAEA,mEAAmE;AACnE;IACI,oFAAoF;IACpF,kDAAkD;IAClD,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,+EAA+E;IAC/E,gBAAgB;IAChB,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,+BAA+B;IAC/B,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,qBAAqB;IACrB,6EAA6E;AACjF;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,4EAA4E;AAChF;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,yDAAyD;AAC7D;;AAEA;IACI,wBAAwB;IACxB,UAAU;IACV,8CAA8C;AAClD;;AAEA;IACI,wBAAwB;IACxB,uBAAuB;IACvB,WAAW;IACX,+BAA+B;IAC/B,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,qBAAqB;IACrB,8DAA8D;IAC9D,6CAA6C;AACjD;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,qCAAqC;IACrC,kBAAkB;IAClB,kDAAkD;AACtD;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,oFAAoF;IACpF,kDAAkD;IAClD,2CAA2C;IAC3C,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,+BAA+B;IAC/B,qBAAqB;IACrB,kDAAkD;IAClD,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,qCAAqC;AACzC;;AAEA,mEAAmE;AACnE;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,OAAO,UAAU,EAAE,wBAAwB,KAAK;AACpD;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,8FAA8F;IAC9F,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA,uCAAuC;AACvC;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR;;;;;gFAK4E;IAC5E;;;;;iBAKa;IACb;;;;;iBAKa;IACb,+CAA+C;IAC/C,sBAAsB;IACtB,oBAAoB;IACpB,UAAU;AACd;;AAEA,oCAAoC;AACpC;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,+EAA+E;IAC/E,WAAW;IACX,aAAa;IACb,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,yCAAyC;AAC7C;;AAEA,mCAAmC;AACnC;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,6EAA6E;IAC7E,cAAc;IACd,YAAY;IACZ,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,uCAAuC;IACvC,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,oCAAoC;IACpC,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,qCAAqC;IACrC,gBAAgB;IAChB,wBAAwB;IACxB,iBAAiB;IACjB,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,qBAAqB;IACrB,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,OAAO;IACP,WAAW;IACX,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,6BAA6B;IAC7B,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,qBAAqB;IACrB,+BAA+B;IAC/B,4BAA4B;IAC5B,6DAA6D;AACjE;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA,mEAAmE;AACnE;IACI,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,4CAA4C;IAC5C,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,4CAA4C;IAC5C,wBAAwB;IACxB,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,mEAAmE;AACnE;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,wBAAwB;IACxB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA,mEAAmE;AACnE;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,wBAAwB;IACxB,qBAAqB;IACrB,sBAAsB;IACtB,2CAA2C;AAC/C;;AAEA,kEAAkE;AAClE;IACI,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;IAC1B,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;AACtB;;AAEA,mEAAmE;AACnE;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,+BAA+B;IAC/B,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,wBAAwB;IACxB,iCAAiC;IACjC,+BAA+B;IAC/B,qBAAqB;IACrB,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,gDAAgD;IAChD,aAAa;AACjB;;AAEA;;IAEI,iCAAiC;IACjC,+CAA+C;AACnD;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA,mEAAmE;AACnE;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,iCAAiC;IACjC,+BAA+B;IAC/B,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,6DAA6D;IAC7D,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,6BAA6B;IAC7B,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA,mEAAmE;AACnE;IACI,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA,mEAAmE;AACnE;IACI,qBAAqB;IACrB,+BAA+B;IAC/B,+BAA+B;IAC/B,oBAAoB;IACpB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,mEAAmE;AACnE;IACI,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;IACX,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,YAAY;IACZ,+BAA+B;IAC/B,eAAe;IACf,8DAA8D;IAC9D,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA,mEAAmE;AACnE;IACI,WAAW,wBAAwB,EAAE;IACrC,YAAY,2BAA2B,EAAE;IACzC,YAAY,0BAA0B,EAAE;IACxC,YAAY,2BAA2B,EAAE;IACzC,YAAY,0BAA0B,EAAE;IACxC,YAAY,2BAA2B,EAAE;IACzC,YAAY,0BAA0B,EAAE;AAC5C;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,+BAA+B;IAC/B,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA,mEAAmE;AACnE;IACI,6BAA6B;IAC7B,wBAAwB;IACxB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,sBAAsB;IACtB,kDAAkD;AACtD;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,kBAAkB;IAClB,wBAAwB;IACxB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,qBAAqB;IACrB,yBAAyB;IACzB,aAAa;IACb,sCAAsC;AAC1C;;AAEA;IACI,wBAAwB;IACxB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA,mEAAmE;AACnE;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,+BAA+B;IAC/B,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA,oEAAoE;AACpE;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,kCAAkC;IAClC,oDAAoD;IACpD,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,wBAAwB;IACxB,sBAAsB;IACtB,uBAAuB;IACvB,sCAAsC;AAC1C;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,wBAAwB;IACxB,kBAAkB;IAClB,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA,mEAAmE;AACnE;IACI,iBAAiB;IACjB,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;IAChB,MAAM;IACN,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,yBAAyB;IACzB,uCAAuC;IACvC,+BAA+B;IAC/B,eAAe;IACf,kBAAkB;IAClB,6BAA6B;IAC7B,yCAAyC;AAC7C;;AAEA;IACI,iCAAiC;IACjC,WAAW;AACf;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,0BAA0B;IAC1B,sCAAsC;IACtC,gBAAgB;IAChB,MAAM;IACN,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,wBAAwB;IACxB,qBAAqB;IACrB,+BAA+B;IAC/B,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gDAAgD;AACpD;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,+BAA+B;IAC/B,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;IACvB,6BAA6B;IAC7B,gBAAgB;IAChB,YAAY;IACZ,+BAA+B;IAC/B,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,mEAAmE;AACnE;IACI,qBAAqB;IACrB,+BAA+B;IAC/B,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,OAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,iCAAiC;IACjC,+BAA+B;IAC/B,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;IAC/B,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,iCAAiC;IACjC,+BAA+B;IAC/B,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,+BAA+B;IAC/B,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,0BAA0B;IAC1B,uBAAuB;IACvB,+BAA+B;IAC/B,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,OAAO;IACP,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mCAAmC;IACnC,oBAAoB;IACpB,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,eAAe,wBAAwB,EAAE,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,+BAA+B,EAAE,eAAe,EAAE,kBAAkB,EAAE,6BAA6B,EAAE;AAC9L,eAAe,wBAAwB,EAAE,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,+BAA+B,EAAE,eAAe,EAAE,kBAAkB,EAAE,6BAA6B,EAAE;AAC9L,eAAe,wBAAwB,EAAE,wBAAwB,EAAE,WAAW,EAAE,YAAY,EAAE,+BAA+B,EAAE,eAAe,EAAE,kBAAkB,EAAE,6BAA6B,EAAE,cAAc,EAAE;AACnN,eAAe,wBAAwB,EAAE,mBAAmB,EAAE,WAAW,EAAE,YAAY,EAAE,+BAA+B,EAAE,eAAe,EAAE,kBAAkB,EAAE,6BAA6B,EAAE;AAC9L,eAAe,uBAAuB,EAAE,uBAAuB,EAAE,wBAAwB,EAAE,+BAA+B,EAAE,+BAA+B,EAAE,eAAe,EAAE,kBAAkB,EAAE,cAAc,EAAE,6BAA6B,EAAE;AACjP,kBAAkB,gCAAgC,EAAE,mBAAmB,EAAE;AACzE,uFAAuF,aAAa,EAAE,mBAAmB,EAAE;;AAE3H,mEAAmE;AACnE;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,sBAAsB;IACtB,6BAA6B;IAC7B,gBAAgB;IAChB,YAAY;IACZ,+BAA+B;IAC/B,eAAe;IACf,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,8CAA8C;IAC9C,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,OAAO,UAAU,EAAE;IACnB,OAAO,UAAU,EAAE;AACvB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,0BAA0B;IAC1B,+BAA+B;IAC/B,+BAA+B;IAC/B,gBAAgB;IAChB,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,+BAA+B;IAC/B,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,wBAAwB;IACxB,sBAAsB;IACtB,6CAA6C;IAC7C,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,0CAA0C;IAC1C,OAAO;AACX;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,qBAAqB;IACrB,+BAA+B;IAC/B,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,OAAO;IACP,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,mEAAmE;AACnE;IACI,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,mCAAmC;IACnC,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,gBAAgB;IAChB,wBAAwB;IACxB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kEAAkE;IAClE,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,yCAAyC;IACzC,wBAAwB;IACxB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,sCAAsC;IACtC,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA,mDAAmD;AACnD;IACI,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,SAAS;IACT,UAAU;IACV,8BAA8B;IAC9B,+BAA+B;IAC/B,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,+BAA+B;IAC/B,cAAc;IACd,4BAA4B;AAChC;;AAEA,mEAAmE;AACnE;IACI,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,SAAS;IACT,WAAW;IACX,8BAA8B;IAC9B,+BAA+B;IAC/B,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,uBAAuB;IACvB,+BAA+B;IAC/B,cAAc;IACd,4BAA4B;AAChC;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,mCAAmC;IACnC,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,gBAAgB;IAChB,wBAAwB;IACxB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kEAAkE;IAClE,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,yCAAyC;IACzC,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,yCAAyC;IACzC,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA,mEAAmE;AACnE;IACI,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,uBAAuB;IACvB,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,uCAAuC;IACvC,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;IAC9B,qCAAqC;IACrC,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA,kEAAkE;AAClE;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA,0CAA0C;AAC1C;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,WAAW;IACX,6DAA6D;IAC7D,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,kEAAkE;AACtE;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,2BAA2B;IAC3B,6BAA6B;IAC7B,iCAAiC;IACjC,qBAAqB;IACrB,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mCAAmC;IACnC,wBAAwB;IACxB,+BAA+B;IAC/B,gBAAgB;IAChB,+EAA+E;IAC/E,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,UAAU;IACV,mDAAmD;AACvD;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,mEAAmE;AACnE;IACI,UAAU;IACV,8BAA8B;AAClC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,mCAAmC;IACnC,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,kEAAkE;IAClE,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,yCAAyC;IACzC,wBAAwB;IACxB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,qFAAqF;IACrF,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR;;;;;mFAK+E;IAC/E;;;;;mBAKe;IACf;;;;;mBAKe;IACf,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,+BAA+B;IAC/B,gBAAgB;IAChB,iCAAiC;IACjC,+EAA+E;AACnF;;AAEA;IACI,WAAW;IACX,cAAc;IACd,UAAU;IACV,yEAAyE;AAC7E;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,+BAA+B;IAC/B,qCAAqC;IACrC,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,mEAAmE;IACnE,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,+BAA+B;IAC/B,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA,mEAAmE;AACnE;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,0BAA0B;IAC9B;;IAEA;QACI,6BAA6B;IACjC;;IAEA;QACI,sBAAsB;QACtB,+BAA+B;QAC/B,4BAA4B;IAChC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,UAAU;QACV,WAAW;QACX,gBAAgB;QAChB,cAAc;QACd,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,SAAS;QACT,UAAU;IACd;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,8BAA8B;QAC9B,WAAW;IACf;;IAEA;QACI,UAAU;QACV,WAAW;QACX,gBAAgB;QAChB,cAAc;QACd,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;QACI,SAAS;QACT,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;AACJ;;AAEA,mEAAmE;AACnE;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;IAChB,wBAAwB;IACxB,sBAAsB;IACtB,6CAA6C;AACjD;;AAEA,iBAAiB,uBAAuB,EAAE;;AAE1C;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,iCAAiC;IACjC,+BAA+B;IAC/B,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,+BAA+B;IAC/B,+BAA+B;IAC/B,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,wBAAwB;IACxB,OAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB,kCAAkC;IAClC,+BAA+B;IAC/B,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,6DAA6D;IAC7D,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;IACvB,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,qBAAqB;IACrB,+BAA+B;IAC/B,+BAA+B;IAC/B,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,OAAO;IACP,YAAY;AAChB;;AAEA,mBAAmB,gBAAgB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;AAC7E,mBAAmB,iBAAiB,EAAE,mBAAmB,EAAE;AAC3D,mBAAmB,iBAAiB,EAAE,wBAAwB,EAAE,kBAAkB,EAAE;;AAEpF;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;IAC1B,+BAA+B;IAC/B,+BAA+B;IAC/B,eAAe;IACf,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA,iBAAiB,8BAA8B,EAAE;;AAEjD;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA,mEAAmE;AACnE;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,+BAA+B;IAC/B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,+BAA+B;IAC/B,+BAA+B;IAC/B,uBAAuB;IACvB,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,mCAAmC;IACnC,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA,mEAAmE;AACnE;IACI,WAAW;IACX,uBAAuB;IACvB,iCAAiC;IACjC,+BAA+B;IAC/B,qBAAqB;IACrB,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,aAAa;AACjB;;AAEA,wBAAwB,iCAAiC,EAAE;;AAE3D;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,uBAAuB;IACvB,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,mEAAmE;AACnE;IACI,0BAA0B;IAC1B,+BAA+B;IAC/B,+BAA+B;IAC/B,qBAAqB;IACrB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;IACxB,qCAAqC;IACrC,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;AACtB","sourcesContent":["/* ── Design Tokens ───────────────────────────────────────────── */\n:root {\n    --bg:            #FAF6F0;\n    --surface:       #F2E8DA;\n    --surface-alt:   #EAD9C4;\n    --brown-dark:    #4A2512;\n    --brown:         #7B4A2D;\n    --brown-light:   #B8855A;\n    --pink:          #E0849A;\n    --pink-light:    #E8B4C0;\n    --pink-dark:     #A85C72;\n    --black:         #1A0F0A;\n    --text-muted:    #7A6055;\n    --border:        #D4B896;\n    --border-focus:  #C4768A;\n    --shadow-sm:     0 1px 3px rgba(74, 37, 18, 0.08);\n    --shadow-md:     0 4px 16px rgba(74, 37, 18, 0.12);\n    --shadow-lg:     0 8px 32px rgba(74, 37, 18, 0.16);\n    --radius-sm:     6px;\n    --radius-md:     12px;\n    --radius-lg:     20px;\n    --font-serif:    'Playfair Display', Georgia, serif;\n    --font-sans:     'Lato', system-ui, sans-serif;\n    --font-script:   'Dancing Script', cursive;\n}\n\n/* ── Reset & Base ────────────────────────────────────────────── */\n*, *::before, *::after {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n}\n\nhtml {\n    scroll-behavior: smooth;\n    scrollbar-gutter: stable;\n}\n\nhtml,\nbody,\n#root {\n    width: 100%;\n    max-width: 100%;\n    overflow-x: hidden;\n}\n\nbody {\n    font-family: var(--font-sans);\n    background-color: var(--bg);\n    color: var(--black);\n    line-height: 1.6;\n    font-size: 16px;\n    -webkit-font-smoothing: antialiased;\n}\n\nimg, iframe, input, textarea, select, button {\n    max-width: 100%;\n}\n\n/* ── Header ──────────────────────────────────────────────────── */\n.header {\n    background: linear-gradient(160deg, #3a1a0a 0%, var(--brown-dark) 60%, #5a2e14 100%);\n    border-bottom: 1px solid rgba(196, 118, 138, 0.25);\n    padding: 0 2.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 80px;\n    box-shadow: 0 4px 24px rgba(30, 10, 4, 0.35), 0 1px 0 rgba(196, 118, 138, 0.15);\n    position: sticky;\n    top: 0;\n    z-index: 100;\n}\n\n.header-brand {\n    font-family: var(--font-script);\n    font-size: 2.1rem;\n    font-weight: 700;\n    color: #fff;\n    letter-spacing: 0.02em;\n    text-decoration: none;\n    text-shadow: 0 2px 12px rgba(0, 0, 0, 0.5), 0 1px 0 rgba(255, 255, 255, 0.08);\n}\n\n.header-brand span {\n    font-size: 1.65rem;\n    color: var(--pink-light);\n    text-shadow: 0 0 24px rgba(232, 180, 192, 0.7), 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.header-nav {\n    display: flex;\n    align-items: center;\n    gap: 2rem;\n}\n\n.header-nav-link {\n    font-family: var(--font-sans);\n    font-size: 0.78rem;\n    font-weight: 600;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    color: var(--surface-alt);\n    text-decoration: none;\n    opacity: 0.8;\n    transition: color 0.15s, opacity 0.15s, text-shadow 0.15s;\n}\n\n.header-nav-link:hover {\n    color: var(--pink-light);\n    opacity: 1;\n    text-shadow: 0 0 12px rgba(232, 180, 192, 0.5);\n}\n\n.header-nav-cta {\n    padding: 0.55rem 1.35rem;\n    background: var(--pink);\n    color: #fff;\n    border-radius: var(--radius-lg);\n    font-family: var(--font-sans);\n    font-size: 0.8rem;\n    font-weight: 700;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    text-decoration: none;\n    transition: background 0.15s, transform 0.1s, box-shadow 0.15s;\n    box-shadow: 0 2px 8px rgba(168, 92, 114, 0.3);\n}\n\n.header-nav-cta:hover {\n    background: var(--pink-dark);\n    transform: translateY(-1px);\n    box-shadow: 0 4px 14px rgba(168, 92, 114, 0.4);\n}\n\n.header-hamburger {\n    display: none;\n    flex-direction: column;\n    justify-content: center;\n    gap: 5px;\n    background: none;\n    border: none;\n    cursor: pointer;\n    padding: 4px;\n    margin-left: 0.25rem;\n}\n\n.header-hamburger span {\n    display: block;\n    width: 22px;\n    height: 2px;\n    background: rgba(255, 255, 255, 0.85);\n    border-radius: 2px;\n    transition: transform 0.2s ease, opacity 0.2s ease;\n}\n\n.header-hamburger.is-open span:nth-child(1) {\n    transform: translateY(7px) rotate(45deg);\n}\n\n.header-hamburger.is-open span:nth-child(2) {\n    opacity: 0;\n}\n\n.header-hamburger.is-open span:nth-child(3) {\n    transform: translateY(-7px) rotate(-45deg);\n}\n\n.header-mobile-menu {\n    position: fixed;\n    top: 60px;\n    left: 0;\n    right: 0;\n    background: linear-gradient(160deg, #3a1a0a 0%, var(--brown-dark) 60%, #5a2e14 100%);\n    border-bottom: 1px solid rgba(196, 118, 138, 0.25);\n    box-shadow: 0 8px 24px rgba(30, 10, 4, 0.4);\n    z-index: 99;\n    display: flex;\n    flex-direction: column;\n}\n\n.header-mobile-menu-link {\n    padding: 1rem 1.5rem;\n    font-family: var(--font-sans);\n    font-size: 0.78rem;\n    font-weight: 600;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    color: rgba(255, 255, 255, 0.8);\n    text-decoration: none;\n    border-bottom: 1px solid rgba(196, 118, 138, 0.12);\n    transition: color 0.15s, background 0.15s;\n}\n\n.header-mobile-menu-link:last-child {\n    border-bottom: none;\n}\n\n.header-mobile-menu-link:hover {\n    color: var(--pink-light);\n    background: rgba(196, 118, 138, 0.08);\n}\n\n/* ── Hero ────────────────────────────────────────────────────── */\n@keyframes heroFadeUp {\n    from { opacity: 0; transform: translateY(28px); }\n    to   { opacity: 1; transform: translateY(0);    }\n}\n\n.hero {\n    position: relative;\n    min-height: 85vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    background: linear-gradient(150deg, var(--surface) 0%, var(--bg) 55%, var(--surface-alt) 100%);\n    padding: 6rem 2rem 7rem;\n    overflow: hidden;\n}\n\n/* Scattered confetti / sprinkle dots */\n.hero::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background-image:\n        radial-gradient(circle, rgba(196,118,138,0.50) 3px,   transparent 3px),\n        radial-gradient(circle, rgba(184,133,90,0.38)  2px,   transparent 2px),\n        radial-gradient(circle, rgba(74,37,18,0.12)    2.5px, transparent 2.5px),\n        radial-gradient(circle, rgba(232,180,192,0.55) 2px,   transparent 2px),\n        radial-gradient(circle, rgba(196,118,138,0.22) 1.5px, transparent 1.5px);\n    background-size:\n        82px 82px,\n        58px 58px,\n        108px 108px,\n        68px 68px,\n        46px 46px;\n    background-position:\n        8px 18px,\n        36px 48px,\n        62px 14px,\n        22px 68px,\n        52px 36px;\n    transform: translateY(var(--dot-parallax, 0px));\n    will-change: transform;\n    pointer-events: none;\n    z-index: 0;\n}\n\n/* Soft pink glow blob — top right */\n.hero::after {\n    content: '';\n    position: absolute;\n    width: 640px;\n    height: 640px;\n    border-radius: 50%;\n    background: radial-gradient(circle, rgba(196,118,138,0.13) 0%, transparent 68%);\n    top: -220px;\n    right: -180px;\n    pointer-events: none;\n    z-index: 0;\n}\n\n.hero-inner {\n    position: relative;\n    z-index: 1;\n    max-width: 720px;\n    opacity: 0;\n}\n\n.hero-inner--ready {\n    animation: heroFadeUp 0.85s ease-out both;\n}\n\n/* Second glow blob — bottom left */\n.hero-blob {\n    position: absolute;\n    width: 500px;\n    height: 500px;\n    border-radius: 50%;\n    background: radial-gradient(circle, rgba(184,133,90,0.1) 0%, transparent 70%);\n    bottom: -180px;\n    left: -140px;\n    pointer-events: none;\n    z-index: 0;\n}\n\n.hero-eyebrow {\n    display: block;\n    font-family: var(--font-script);\n    font-size: clamp(1.5rem, 3.5vw, 2.2rem);\n    color: var(--brown);\n    margin-bottom: 0.6rem;\n    opacity: 0.9;\n}\n\n.hero-logo {\n    display: block;\n    max-width: clamp(260px, 50vw, 480px);\n    height: auto;\n    margin: 0 auto 1rem;\n}\n\n.hero-title {\n    font-family: var(--font-serif);\n    font-size: clamp(2.8rem, 8vw, 5.5rem);\n    font-weight: 600;\n    color: var(--brown-dark);\n    line-height: 1.08;\n    margin-bottom: 1.5rem;\n    letter-spacing: -0.01em;\n}\n\n.hero-title em {\n    font-style: italic;\n    color: rgb(254, 137, 153);\n}\n\n.hero-title-by {\n    display: block;\n    font-size: 0.38em;\n    font-weight: 400;\n    font-style: italic;\n    color: var(--brown);\n    letter-spacing: 0.04em;\n    margin-top: 0.5em;\n    opacity: 0.85;\n}\n\n.hero-divider {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0.6rem;\n    margin: 0 auto 1.5rem;\n    width: 160px;\n}\n\n.hero-divider::before,\n.hero-divider::after {\n    content: '';\n    flex: 1;\n    height: 1px;\n    background: var(--brown-light);\n    opacity: 0.45;\n}\n\n.hero-divider-dot {\n    width: 5px;\n    height: 5px;\n    border-radius: 50%;\n    background: var(--pink);\n    opacity: 0.65;\n    display: inline-block;\n}\n\n.hero-subtitle {\n    font-size: clamp(1rem, 2vw, 1.15rem);\n    color: var(--text-muted);\n    font-weight: 400;\n    max-width: 460px;\n    margin: 0 auto 2.75rem;\n    line-height: 1.75;\n    letter-spacing: 0.01em;\n}\n\n.hero-cta {\n    display: inline-block;\n    padding: 1rem 2.75rem;\n    background: var(--brown-dark);\n    color: var(--bg);\n    font-family: var(--font-sans);\n    font-size: 0.82rem;\n    font-weight: 700;\n    letter-spacing: 0.14em;\n    text-transform: uppercase;\n    text-decoration: none;\n    border-radius: var(--radius-lg);\n    box-shadow: var(--shadow-md);\n    transition: background 0.2s, transform 0.15s, box-shadow 0.2s;\n}\n\n.hero-cta:hover {\n    background: var(--brown);\n    transform: translateY(-2px);\n    box-shadow: var(--shadow-lg);\n}\n\n/* ── Process Strip ───────────────────────────────────────────── */\n.process-strip {\n    background: var(--brown-dark);\n    padding: 4rem 2rem;\n}\n\n.process-strip-inner {\n    max-width: 880px;\n    margin: 0 auto;\n    display: grid;\n    grid-template-columns: 1fr auto 1fr auto 1fr;\n    align-items: center;\n    gap: 1rem;\n}\n\n.process-step {\n    text-align: center;\n    padding: 0 1rem;\n}\n\n.process-step-num {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 52px;\n    height: 52px;\n    border-radius: 50%;\n    background: rgba(196, 118, 138, 0.18);\n    border: 1.5px solid rgba(232, 180, 192, 0.5);\n    color: var(--pink-light);\n    font-family: var(--font-serif);\n    font-size: 1.15rem;\n    font-weight: 600;\n    margin: 0 auto 1rem;\n}\n\n.process-step-title {\n    font-family: var(--font-serif);\n    font-size: 1.05rem;\n    color: var(--bg);\n    margin-bottom: 0.4rem;\n    letter-spacing: 0.01em;\n}\n\n.process-step-desc {\n    font-size: 0.82rem;\n    color: var(--surface-alt);\n    line-height: 1.6;\n    opacity: 0.8;\n}\n\n.process-arrow {\n    color: rgba(232, 180, 192, 0.35);\n    font-size: 1.4rem;\n    letter-spacing: 0.2em;\n    text-align: center;\n    user-select: none;\n}\n\n/* ── Page Layout ─────────────────────────────────────────────── */\n#order {\n    scroll-margin-top: 96px;\n}\n\n.page-content {\n    max-width: 1100px;\n    margin: 0 auto;\n    padding: 3rem 2rem 4rem;\n}\n\n.order-section {\n    display: flex;\n    gap: 2.5rem;\n    align-items: flex-start;\n}\n\n.order-section-form {\n    flex: 1;\n    min-width: 0;\n}\n\n.order-section-map {\n    flex: 1;\n    min-width: 0;\n    position: sticky;\n    top: 90px;\n}\n\n.order-section-map-label {\n    font-family: var(--font-serif);\n    font-size: 1.15rem;\n    color: var(--brown-dark);\n    margin-bottom: 0.75rem;\n    font-style: italic;\n}\n\n/* ── Section Heading ─────────────────────────────────────────── */\n.section-heading {\n    font-family: var(--font-serif);\n    font-size: 1.5rem;\n    color: var(--brown-dark);\n    margin-bottom: 1.5rem;\n    padding-bottom: 0.5rem;\n    border-bottom: 2px solid var(--surface-alt);\n}\n\n/* ── Order Delivery / Policy Notices ────────────────────────── */\n.order-delivery-notice {\n    font-size: 0.85rem;\n    color: var(--pink-dark);\n    font-weight: 600;\n    margin-bottom: 0.5rem;\n}\n\n.order-policy-notice {\n    font-size: 0.78rem;\n    color: var(--text-muted);\n    margin-bottom: 1.25rem;\n    line-height: 1.5;\n}\n\n.order-policy-link {\n    color: var(--pink-dark);\n    text-decoration: underline;\n    text-underline-offset: 2px;\n    transition: color 0.15s;\n}\n\n.order-policy-link:hover {\n    color: var(--pink);\n}\n\n/* ── Form Card ───────────────────────────────────────────────── */\n.form-card {\n    background: #fff;\n    border: 1px solid var(--border);\n    border-radius: var(--radius-md);\n    padding: 2rem;\n    box-shadow: var(--shadow-md);\n}\n\n.form-field {\n    margin-bottom: 1.25rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n}\n\n.form-label {\n    font-size: 0.78rem;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: var(--brown);\n}\n\n.form-input,\n.form-textarea {\n    width: 100%;\n    padding: 0.65rem 0.85rem;\n    border: 1.5px solid var(--border);\n    border-radius: var(--radius-sm);\n    background: var(--bg);\n    color: var(--black);\n    font-family: var(--font-sans);\n    font-size: 0.95rem;\n    transition: border-color 0.15s, box-shadow 0.15s;\n    outline: none;\n}\n\n.form-input:focus,\n.form-textarea:focus {\n    border-color: var(--border-focus);\n    box-shadow: 0 0 0 3px rgba(196, 118, 138, 0.18);\n}\n\n.form-textarea {\n    resize: vertical;\n    min-height: 110px;\n}\n\n/* ── Radio Group ─────────────────────────────────────────────── */\n.form-radio-group {\n    display: flex;\n    gap: 0.75rem;\n}\n\n.form-radio-option {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.55rem 1.1rem;\n    border: 1.5px solid var(--border);\n    border-radius: var(--radius-lg);\n    cursor: pointer;\n    font-size: 0.9rem;\n    color: var(--text-muted);\n    transition: border-color 0.15s, background 0.15s, color 0.15s;\n    user-select: none;\n}\n\n.form-radio-option input[type=\"radio\"] {\n    display: none;\n}\n\n.form-radio-option.selected {\n    border-color: var(--pink);\n    background: var(--pink-light);\n    color: var(--brown-dark);\n    font-weight: 700;\n}\n\n/* ── File Input ──────────────────────────────────────────────── */\ninput[type=\"file\"].form-input {\n    padding: 0.45rem 0.6rem;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n\n.form-file-hint {\n    font-size: 0.78rem;\n    color: var(--text-muted);\n    margin-top: 0.2rem;\n}\n\n/* ── SMS Consent ─────────────────────────────────────────────── */\n.sms-consent {\n    background: var(--bg);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-sm);\n    padding: 0.9rem 1rem;\n    margin-bottom: 1.15rem;\n}\n\n.sms-consent-row {\n    display: flex;\n    gap: 0.65rem;\n    align-items: flex-start;\n    cursor: pointer;\n}\n\n.sms-consent-row input[type=\"checkbox\"] {\n    margin-top: 3px;\n    flex-shrink: 0;\n    accent-color: var(--pink);\n    width: 15px;\n    height: 15px;\n    cursor: pointer;\n}\n\n.consent-text {\n    font-size: 0.82rem;\n    color: var(--brown);\n    line-height: 1.65;\n}\n\n.rates-note {\n    font-size: 0.77rem;\n    color: var(--text-muted);\n    margin-top: 0.45rem;\n    padding-left: 1.65rem;\n    line-height: 1.55;\n}\n\n.rates-note a {\n    color: var(--pink);\n}\n\n/* ── Submit Button ───────────────────────────────────────────── */\n.form-submit {\n    width: 100%;\n    margin-top: 0.5rem;\n    padding: 0.8rem 1.5rem;\n    background: var(--pink);\n    color: #fff;\n    font-family: var(--font-sans);\n    font-size: 0.9rem;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    border: none;\n    border-radius: var(--radius-sm);\n    cursor: pointer;\n    transition: background 0.15s, transform 0.1s, box-shadow 0.15s;\n    box-shadow: var(--shadow-sm);\n}\n\n.form-submit:hover:not(:disabled) {\n    background: var(--pink-dark);\n    box-shadow: var(--shadow-md);\n    transform: translateY(-1px);\n}\n\n.form-submit:active:not(:disabled) {\n    transform: translateY(0);\n}\n\n.form-submit:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n}\n\n/* ── Form States ─────────────────────────────────────────────── */\n@keyframes shake {\n    0%, 100% { transform: translateX(0); }\n    15%       { transform: translateX(-6px); }\n    30%       { transform: translateX(6px); }\n    45%       { transform: translateX(-4px); }\n    60%       { transform: translateX(4px); }\n    75%       { transform: translateX(-2px); }\n    90%       { transform: translateX(2px); }\n}\n\n.form-error {\n    background: #fdf2f4;\n    border: 1px solid #f0b8c2;\n    border-radius: var(--radius-sm);\n    color: #9b3a50;\n    font-size: 0.875rem;\n    padding: 0.65rem 0.9rem;\n    margin-top: 1rem;\n    animation: shake 0.5s ease-in-out;\n}\n\n.form-success {\n    text-align: center;\n    padding: 2.5rem 1rem;\n}\n\n.form-success-title {\n    font-family: var(--font-serif);\n    font-size: 1.6rem;\n    color: var(--brown-dark);\n    margin-bottom: 0.5rem;\n}\n\n.form-success-text {\n    color: var(--text-muted);\n    font-size: 0.95rem;\n}\n\n/* ── Footer ──────────────────────────────────────────────────── */\n.footer {\n    background: var(--brown-dark);\n    padding: 3.5rem 2.5rem 0;\n    margin-top: 0;\n}\n\n.footer-inner {\n    max-width: 1100px;\n    margin: 0 auto;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 3rem;\n    padding-bottom: 2.5rem;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.footer-brand-name {\n    font-family: var(--font-serif);\n    font-size: 1.6rem;\n    font-weight: 600;\n    color: var(--bg);\n    letter-spacing: 0.04em;\n    margin-bottom: 0.4rem;\n}\n\n.footer-brand-name span {\n    color: var(--pink-light);\n}\n\n.footer-tagline {\n    display: block;\n    font-family: var(--font-script);\n    font-size: 1.15rem;\n    color: var(--pink-light);\n    opacity: 0.75;\n}\n\n.footer-col-title {\n    font-size: 0.72rem;\n    font-weight: 700;\n    letter-spacing: 0.12em;\n    text-transform: uppercase;\n    color: var(--surface-alt);\n    opacity: 0.5;\n    margin-bottom: 1rem;\n}\n\n.footer-contact {\n    font-size: 0.88rem;\n    color: var(--surface-alt);\n    margin-bottom: 1rem;\n    line-height: 1.6;\n}\n\n.footer-contact a {\n    color: var(--pink-light);\n    text-decoration: none;\n    transition: opacity 0.15s;\n}\n\n.footer-contact a:hover {\n    opacity: 0.75;\n}\n\n.footer-links {\n    display: flex;\n    gap: 1.5rem;\n    flex-wrap: wrap;\n}\n\n.footer-links a {\n    color: var(--surface-alt);\n    font-size: 0.78rem;\n    letter-spacing: 0.06em;\n    text-decoration: none;\n    text-transform: uppercase;\n    opacity: 0.65;\n    transition: color 0.15s, opacity 0.15s;\n}\n\n.footer-links a:hover {\n    color: var(--pink-light);\n    opacity: 1;\n}\n\n.footer-bottom {\n    max-width: 1100px;\n    margin: 0 auto;\n    padding: 1.25rem 0 1.5rem;\n    display: flex;\n    justify-content: center;\n}\n\n.footer-copy {\n    font-size: 0.72rem;\n    color: var(--surface-alt);\n    opacity: 0.4;\n    letter-spacing: 0.03em;\n}\n\n/* ── Status Pages (payment success / cancel) ─────────────────── */\n.status-page {\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    background: var(--bg);\n}\n\n.status-body {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 2rem 1rem;\n}\n\n.status-card {\n    background: #fff;\n    border: 1px solid var(--border);\n    border-radius: var(--radius-md);\n    padding: 3rem 2.5rem;\n    text-align: center;\n    max-width: 460px;\n    width: 100%;\n    box-shadow: var(--shadow-md);\n}\n\n.status-icon {\n    font-size: 2.75rem;\n    margin-bottom: 1rem;\n    display: block;\n}\n\n.status-title {\n    font-family: var(--font-serif);\n    font-size: 1.75rem;\n    color: var(--brown-dark);\n    margin-bottom: 0.75rem;\n}\n\n.status-text {\n    color: var(--text-muted);\n    font-size: 0.95rem;\n    line-height: 1.6;\n}\n\n.status-countdown {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: var(--surface-alt);\n    color: var(--brown);\n    font-weight: 700;\n    border-radius: 50%;\n    width: 1.75rem;\n    height: 1.75rem;\n    font-size: 0.85rem;\n    vertical-align: middle;\n}\n\n/* ── Policy / Legal Pages ─────────────────────────────────────── */\n.policy-page {\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    background: var(--bg);\n}\n\n.policy-content {\n    flex: 1;\n    max-width: 760px;\n    margin: 0 auto;\n    padding: 3rem 2rem 4rem;\n    width: 100%;\n}\n\n.policy-title {\n    font-family: var(--font-serif);\n    font-size: 2rem;\n    color: var(--brown-dark);\n    margin-bottom: 0.35rem;\n}\n\n.policy-meta {\n    color: var(--text-muted);\n    font-size: 0.83rem;\n    margin-bottom: 1.5rem;\n}\n\n.policy-summary {\n    background: var(--surface);\n    border-left: 3px solid var(--pink);\n    border-radius: 0 var(--radius-sm) var(--radius-sm) 0;\n    padding: 0.9rem 1.2rem;\n    font-size: 0.88rem;\n    color: var(--brown);\n    margin-bottom: 2.5rem;\n    line-height: 1.65;\n}\n\n.policy-section {\n    margin-bottom: 2rem;\n}\n\n.policy-section h2 {\n    font-family: var(--font-serif);\n    font-size: 1.1rem;\n    color: var(--brown-dark);\n    margin-bottom: 0.55rem;\n    padding-bottom: 0.35rem;\n    border-bottom: 1px solid var(--border);\n}\n\n.policy-section p {\n    color: var(--black);\n    font-size: 0.9rem;\n    line-height: 1.75;\n    margin-bottom: 0.65rem;\n}\n\n.policy-section ul {\n    padding-left: 1.25rem;\n    margin-bottom: 0.65rem;\n}\n\n.policy-section li {\n    color: var(--black);\n    font-size: 0.9rem;\n    line-height: 1.75;\n    margin-bottom: 0.25rem;\n}\n\n.policy-section a {\n    color: var(--pink-dark);\n    text-decoration: underline;\n}\n\n.policy-footer {\n    text-align: center;\n    padding: 1.25rem 2rem;\n    color: var(--text-muted);\n    font-size: 0.78rem;\n    border-top: 1px solid var(--border);\n    margin-top: 1.5rem;\n}\n\n/* ── Admin Dashboard ─────────────────────────────────────────── */\n.admin-page {\n    min-height: 100vh;\n    background: var(--surface);\n    font-family: var(--font-sans);\n}\n\n.admin-topbar {\n    background: var(--brown-dark);\n    padding: 0.75rem 2rem;\n    min-height: 64px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.75rem;\n    flex-wrap: wrap;\n    box-shadow: var(--shadow-md);\n    position: sticky;\n    top: 0;\n    z-index: 100;\n}\n\n.admin-topbar-brand {\n    font-family: var(--font-serif);\n    font-size: 1.2rem;\n    color: var(--bg);\n    letter-spacing: 0.03em;\n}\n\n.admin-topbar-brand span {\n    color: var(--pink-light);\n}\n\n.admin-topbar-right {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n}\n\n.admin-user-email {\n    font-size: 0.78rem;\n    color: var(--surface-alt);\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 180px;\n}\n\n.admin-logout-btn {\n    padding: 0.3rem 0.75rem;\n    background: transparent;\n    color: var(--surface-alt);\n    border: 1px solid rgba(255,255,255,0.2);\n    border-radius: var(--radius-sm);\n    cursor: pointer;\n    font-size: 0.78rem;\n    font-family: var(--font-sans);\n    transition: background 0.15s, color 0.15s;\n}\n\n.admin-logout-btn:hover {\n    background: rgba(255,255,255,0.1);\n    color: #fff;\n}\n\n.admin-body {\n    padding: 2rem;\n    max-width: 1400px;\n    margin: 0 auto;\n}\n\n.admin-status-msg {\n    color: var(--text-muted);\n    font-size: 0.9rem;\n    padding: 0.5rem 0;\n}\n\n.admin-error {\n    color: #9b3a50;\n    font-size: 0.875rem;\n}\n\n.admin-section-nav {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n    padding: 0.75rem 1rem;\n    margin-bottom: 1rem;\n    background: var(--surface);\n    border-bottom: 1px solid var(--border);\n    position: sticky;\n    top: 0;\n    z-index: 10;\n}\n\n.admin-section-nav-btn {\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n    padding: 0.35rem 0.85rem;\n    background: var(--bg);\n    border: 1px solid var(--border);\n    border-radius: 999px;\n    font-size: 0.8rem;\n    font-weight: 500;\n    color: var(--text);\n    cursor: pointer;\n    transition: background 0.15s, border-color 0.15s;\n}\n\n.admin-section-nav-btn:hover {\n    background: var(--pink-light);\n    border-color: var(--pink);\n}\n\n.admin-board {\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n}\n\n.admin-column {\n    background: #fff;\n    border: 1px solid var(--border);\n    border-radius: var(--radius-md);\n    padding: 1.25rem;\n    box-shadow: var(--shadow-sm);\n}\n\n.admin-column-header {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-bottom: 1rem;\n    font-family: var(--font-serif);\n    font-size: 1rem;\n    color: var(--brown-dark);\n}\n\n.admin-badge {\n    background: var(--surface-alt);\n    color: var(--brown);\n    border-radius: 12px;\n    padding: 0.1rem 0.55rem;\n    font-size: 0.72rem;\n    font-weight: 700;\n    font-family: var(--font-sans);\n}\n\n.admin-login-page {\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    background: var(--bg);\n    gap: 1.25rem;\n}\n\n.admin-login-title {\n    font-family: var(--font-serif);\n    font-size: 1.5rem;\n    color: var(--brown-dark);\n}\n\n.admin-login-btn {\n    padding: 0.7rem 1.75rem;\n    background: var(--brown-dark);\n    color: var(--bg);\n    border: none;\n    border-radius: var(--radius-sm);\n    cursor: pointer;\n    font-family: var(--font-sans);\n    font-size: 0.88rem;\n    font-weight: 700;\n    letter-spacing: 0.07em;\n    text-transform: uppercase;\n    transition: background 0.15s;\n}\n\n.admin-login-btn:hover {\n    background: var(--brown);\n}\n\n/* ── Order Card (admin) ──────────────────────────────────────── */\n.order-card {\n    background: var(--bg);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-sm);\n    padding: 1rem;\n    margin-bottom: 0.75rem;\n    color: var(--black);\n}\n\n.order-card-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 0.5rem;\n}\n\n.order-card-id {\n    font-family: var(--font-serif);\n    font-size: 0.95rem;\n    color: var(--brown-dark);\n    font-weight: 600;\n}\n\n.order-card-meta {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n}\n\n.order-card-date {\n    color: var(--text-muted);\n    font-size: 0.78rem;\n}\n\n.order-card-field {\n    font-size: 0.855rem;\n    color: var(--black);\n    margin: 0.2rem 0;\n}\n\n.order-card-field a {\n    color: var(--pink-dark);\n    text-decoration: underline;\n}\n\n.sms-status {\n    font-size: 1rem;\n    font-weight: 700;\n    margin: 0.4rem 0 0.6rem;\n}\n\n.sms-status--automatic {\n    color: #2d6a4f;\n}\n\n.sms-status--manual {\n    color: #9b2c2c;\n}\n\n.order-card-comments-edit {\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n}\n\n.order-card-comments-view {\n    display: flex;\n    align-items: flex-start;\n    gap: 0.5rem;\n}\n\n.order-card-comments-text {\n    font-size: 0.855rem;\n    color: var(--black);\n    flex: 1;\n    margin: 0.2rem 0;\n}\n\n.order-card-comments-label {\n    display: block;\n    font-weight: 600;\n    margin-bottom: 0.2rem;\n}\n\n.order-card-comments-body {\n    margin: 0;\n    white-space: pre-wrap;\n}\n\n.order-card-comments-none {\n    color: var(--text-muted);\n    font-style: italic;\n}\n\n.order-card-comments-actions {\n    display: flex;\n    gap: 0.4rem;\n}\n\n.order-card-textarea {\n    width: 100%;\n    padding: 0.4rem 0.6rem;\n    border: 1.5px solid var(--border);\n    border-radius: var(--radius-sm);\n    background: #fff;\n    color: var(--black);\n    font-family: var(--font-sans);\n    font-size: 0.855rem;\n    resize: vertical;\n    min-height: 60px;\n    outline: none;\n}\n\n.order-card-textarea:focus {\n    border-color: var(--border-focus);\n}\n\n.order-card-photos {\n    display: flex;\n    gap: 0.5rem;\n    flex-wrap: wrap;\n    margin-top: 0.75rem;\n}\n\n.order-card-thumbnail {\n    width: 80px;\n    height: 80px;\n    object-fit: cover;\n    border-radius: var(--radius-sm);\n    display: block;\n    border: 1px solid var(--border);\n}\n\n.order-card-actions {\n    margin-top: 0.75rem;\n    display: flex;\n    gap: 0.5rem;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n.order-card-input {\n    padding: 0.38rem 0.6rem;\n    border: 1.5px solid var(--border);\n    border-radius: var(--radius-sm);\n    background: #fff;\n    color: var(--black);\n    font-family: var(--font-sans);\n    font-size: 0.855rem;\n    width: 180px;\n    outline: none;\n    max-width: 100%;\n}\n\n.order-card-input:focus {\n    border-color: var(--border-focus);\n}\n\n.order-card-waiting {\n    color: var(--text-muted);\n    font-style: italic;\n    font-size: 0.83rem;\n    margin: 0;\n}\n\n.order-card-urgent-notice {\n    background: #fdf2f4;\n    border: 1px solid #f0b8c2;\n    border-radius: var(--radius-sm);\n    color: #9b3a50;\n    font-size: 0.83rem;\n    font-weight: 600;\n    padding: 0.55rem 0.8rem;\n    margin: 0;\n}\n\n.order-card-url-box {\n    margin-top: 0.75rem;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    background: var(--surface);\n    padding: 0.5rem 0.75rem;\n    border-radius: var(--radius-sm);\n    border: 1px solid var(--border);\n}\n\n.order-card-url-text {\n    font-size: 0.78rem;\n    word-break: break-all;\n    flex: 1;\n    color: var(--brown);\n}\n\n.order-card-refund-section {\n    margin-top: 1rem;\n    border-top: 1px solid var(--border);\n    padding-top: 0.75rem;\n    display: flex;\n    gap: 0.5rem;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n.order-card-refund-label {\n    font-size: 0.8rem;\n    color: var(--text-muted);\n}\n\n.order-card-error {\n    color: #9b3a50;\n    font-size: 0.83rem;\n    margin-top: 0.5rem;\n}\n\n.btn-accept  { padding: 0.38rem 0.85rem; background: #16a34a; color: #fff; border: none; border-radius: var(--radius-sm); cursor: pointer; font-size: 0.83rem; font-family: var(--font-sans); }\n.btn-reject  { padding: 0.38rem 0.85rem; background: #dc2626; color: #fff; border: none; border-radius: var(--radius-sm); cursor: pointer; font-size: 0.83rem; font-family: var(--font-sans); }\n.btn-copy    { padding: 0.32rem 0.65rem; background: var(--brown); color: #fff; border: none; border-radius: var(--radius-sm); cursor: pointer; font-size: 0.78rem; font-family: var(--font-sans); flex-shrink: 0; }\n.btn-refund  { padding: 0.38rem 0.85rem; background: #b45309; color: #fff; border: none; border-radius: var(--radius-sm); cursor: pointer; font-size: 0.83rem; font-family: var(--font-sans); }\n.btn-icon    { padding: 0.2rem 0.45rem; background: transparent; color: var(--text-muted); border: 1px solid var(--border); border-radius: var(--radius-sm); cursor: pointer; font-size: 0.72rem; line-height: 1; font-family: var(--font-sans); }\n.btn-icon:hover { border-color: var(--brown-light); color: var(--brown); }\n.btn-accept:disabled, .btn-reject:disabled, .btn-copy:disabled, .btn-refund:disabled { opacity: 0.55; cursor: not-allowed; }\n\n/* ── Options Manager ─────────────────────────────────────────── */\n.options-manager {\n    margin-bottom: 1.25rem;\n}\n\n.options-manager-toggle {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.55rem;\n    padding: 0.5rem 1.1rem;\n    background: var(--brown-dark);\n    color: var(--bg);\n    border: none;\n    border-radius: var(--radius-sm);\n    cursor: pointer;\n    font-family: var(--font-sans);\n    font-size: 0.8rem;\n    font-weight: 700;\n    letter-spacing: 0.07em;\n    text-transform: uppercase;\n    transition: background 0.15s, box-shadow 0.15s;\n    box-shadow: var(--shadow-sm);\n}\n\n.options-manager-toggle:hover {\n    background: var(--brown);\n    box-shadow: var(--shadow-md);\n}\n\n.options-manager-icon {\n    font-size: 0.85rem;\n    opacity: 0.8;\n}\n\n.options-manager-chevron {\n    font-size: 0.75rem;\n    display: inline-block;\n    transition: transform 0.2s ease;\n}\n\n.options-manager-toggle.is-open .options-manager-chevron {\n    transform: rotate(180deg);\n}\n\n@keyframes omFadeIn {\n    from { opacity: 0; }\n    to   { opacity: 1; }\n}\n\n.options-manager-body {\n    margin-top: 0.75rem;\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 1rem;\n    background: var(--surface);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-md);\n    padding: 1.25rem;\n    box-shadow: var(--shadow-sm);\n    animation: omFadeIn 0.15s ease;\n}\n\n.options-panel {\n    background: #fff;\n    border: 1px solid var(--border);\n    border-radius: var(--radius-sm);\n    padding: 1rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n}\n\n.options-panel-title {\n    font-family: var(--font-serif);\n    font-size: 0.95rem;\n    color: var(--brown-dark);\n    padding-bottom: 0.5rem;\n    border-bottom: 1.5px solid var(--surface-alt);\n    margin: 0;\n}\n\n.options-list {\n    list-style: none;\n    display: flex;\n    flex-direction: column;\n    gap: 0.3rem;\n    max-height: 180px;\n    overflow-y: auto;\n    scrollbar-width: thin;\n    scrollbar-color: var(--border) transparent;\n    flex: 1;\n}\n\n.options-list-item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0.35rem 0.6rem;\n    background: var(--bg);\n    border-radius: var(--radius-sm);\n    font-size: 0.875rem;\n    color: var(--black);\n    transition: background 0.1s;\n}\n\n.options-list-item:hover {\n    background: var(--surface-alt);\n}\n\n.options-add-row {\n    display: flex;\n    gap: 0.5rem;\n}\n\n.options-add-row .form-input {\n    flex: 1;\n    font-size: 0.875rem;\n    padding: 0.4rem 0.65rem;\n}\n\n@media (max-width: 860px) {\n    .options-manager-body {\n        grid-template-columns: 1fr;\n    }\n}\n\n.audit-log-body {\n    margin-top: 0.75rem;\n    animation: omFadeIn 0.15s ease;\n}\n\n.audit-log-list {\n    max-height: 320px;\n}\n\n.audit-log-item {\n    justify-content: flex-start;\n    gap: 0.65rem;\n}\n\n.audit-log-message {\n    flex: 1;\n}\n\n.audit-log-timestamp {\n    color: var(--text-muted);\n    font-size: 0.78rem;\n    white-space: nowrap;\n}\n\n.audit-severity-badge {\n    border-radius: 12px;\n    padding: 0.1rem 0.55rem;\n    font-size: 0.72rem;\n    font-weight: 700;\n    font-family: var(--font-sans);\n    white-space: nowrap;\n}\n\n.audit-severity-info {\n    background: var(--surface-alt);\n    color: var(--brown);\n}\n\n.audit-severity-warning {\n    background: #fdf0d5;\n    color: #9a6b12;\n}\n\n.audit-severity-error {\n    background: #fbe4e9;\n    color: #9b3a50;\n}\n\n/* ── Story / Meet the Baker ──────────────────────────────────── */\n.story-section {\n    background: var(--surface);\n    padding: 6rem 2rem;\n}\n\n.story-inner {\n    max-width: 1100px;\n    margin: 0 auto;\n    display: flex;\n    gap: 5rem;\n    align-items: center;\n}\n\n.story-content {\n    flex: 1;\n    min-width: 0;\n}\n\n.story-eyebrow {\n    display: block;\n    font-family: var(--font-script);\n    font-size: clamp(1.4rem, 3vw, 2rem);\n    color: var(--pink);\n    margin-bottom: 0.35rem;\n}\n\n.story-heading {\n    font-family: var(--font-serif);\n    font-size: clamp(2rem, 4vw, 2.75rem);\n    font-weight: 600;\n    color: var(--brown-dark);\n    line-height: 1.12;\n    margin-bottom: 1.25rem;\n}\n\n.story-rule {\n    width: 48px;\n    height: 2px;\n    background: linear-gradient(90deg, var(--pink), var(--pink-light));\n    border-radius: 2px;\n    margin-bottom: 1.5rem;\n}\n\n.story-body {\n    font-size: clamp(0.92rem, 1.8vw, 1.02rem);\n    color: var(--text-muted);\n    line-height: 1.9;\n    margin-bottom: 2rem;\n}\n\n.story-tags {\n    display: flex;\n    gap: 0.6rem;\n    flex-wrap: wrap;\n}\n\n.story-tag {\n    display: inline-block;\n    padding: 0.35rem 1rem;\n    border: 1.5px solid var(--brown-light);\n    border-radius: var(--radius-lg);\n    font-size: 0.72rem;\n    font-weight: 700;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    color: var(--brown);\n}\n\n/* Offset decorative block peeks behind the photo */\n.story-photo-wrap {\n    flex: 0 0 396px;\n    position: relative;\n    padding-right: 16px;\n    padding-bottom: 16px;\n}\n\n.story-photo-wrap::after {\n    content: '';\n    position: absolute;\n    top: 16px;\n    right: 0;\n    bottom: 0;\n    left: 16px;\n    background: var(--surface-alt);\n    border-radius: var(--radius-lg);\n    z-index: 0;\n}\n\n.story-photo {\n    position: relative;\n    z-index: 1;\n    width: 100%;\n    aspect-ratio: 3 / 4;\n    object-fit: cover;\n    object-position: top;\n    border-radius: var(--radius-lg);\n    display: block;\n    box-shadow: var(--shadow-lg);\n}\n\n/* ── Policies & Booking ──────────────────────────────────────── */\n#policies {\n    scroll-margin-top: 96px;\n}\n\n.policies-section {\n    background: var(--bg);\n    padding: 6rem 2rem;\n}\n\n.policies-inner {\n    max-width: 1100px;\n    margin: 0 auto;\n    display: flex;\n    gap: 5rem;\n    align-items: center;\n}\n\n.policies-photo-wrap {\n    flex: 0 0 396px;\n    position: relative;\n    padding-left: 16px;\n    padding-bottom: 16px;\n}\n\n.policies-photo-wrap::after {\n    content: '';\n    position: absolute;\n    top: 16px;\n    left: 0;\n    bottom: 0;\n    right: 16px;\n    background: var(--surface-alt);\n    border-radius: var(--radius-lg);\n    z-index: 0;\n}\n\n.policies-photo {\n    position: relative;\n    z-index: 1;\n    width: 100%;\n    aspect-ratio: 3 / 4;\n    object-fit: cover;\n    object-position: center;\n    border-radius: var(--radius-lg);\n    display: block;\n    box-shadow: var(--shadow-lg);\n}\n\n.policies-content {\n    flex: 1;\n    min-width: 0;\n}\n\n.policies-eyebrow {\n    display: block;\n    font-family: var(--font-script);\n    font-size: clamp(1.4rem, 3vw, 2rem);\n    color: var(--pink);\n    margin-bottom: 0.35rem;\n}\n\n.policies-heading {\n    font-family: var(--font-serif);\n    font-size: clamp(2rem, 4vw, 2.75rem);\n    font-weight: 600;\n    color: var(--brown-dark);\n    line-height: 1.12;\n    margin-bottom: 1.25rem;\n}\n\n.policies-rule {\n    width: 48px;\n    height: 2px;\n    background: linear-gradient(90deg, var(--pink), var(--pink-light));\n    border-radius: 2px;\n    margin-bottom: 1.5rem;\n}\n\n.policies-list {\n    list-style: none;\n    display: flex;\n    flex-direction: column;\n    gap: 1.35rem;\n    margin-bottom: 0;\n}\n\n.policies-item {\n    display: flex;\n    flex-direction: column;\n    gap: 0.2rem;\n    padding-left: 1.5rem;\n    position: relative;\n}\n\n.policies-item::before {\n    content: '✦';\n    position: absolute;\n    left: 0;\n    top: 0.15rem;\n    font-size: 0.65rem;\n    color: var(--pink);\n    line-height: 1.8;\n}\n\n.policies-item-label {\n    font-family: var(--font-script);\n    font-size: clamp(1.15rem, 2.5vw, 1.45rem);\n    color: var(--brown-dark);\n    line-height: 1.2;\n}\n\n.policies-item-text {\n    font-size: clamp(0.88rem, 1.7vw, 0.97rem);\n    color: var(--text-muted);\n    line-height: 1.85;\n}\n\n/* ── Gallery Preview Strips ──────────────────────────────────── */\n.preview-section {\n    padding: 4rem 0 3rem;\n    background: var(--bg);\n}\n\n.preview-section--alt {\n    background: var(--surface);\n}\n\n.preview-header {\n    max-width: 1100px;\n    margin: 0 auto;\n    padding: 0 2rem 1.25rem;\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    gap: 1rem;\n}\n\n.preview-eyebrow {\n    display: block;\n    font-family: var(--font-script);\n    font-size: clamp(1.1rem, 2.5vw, 1.5rem);\n    color: var(--pink);\n    margin-bottom: 0.2rem;\n}\n\n.preview-heading {\n    font-family: var(--font-serif);\n    font-size: clamp(1.6rem, 3vw, 2.2rem);\n    font-weight: 600;\n    color: var(--brown-dark);\n    line-height: 1.1;\n    margin: 0;\n}\n\n.preview-view-all {\n    font-family: var(--font-sans);\n    font-size: 0.8rem;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    color: var(--brown-light);\n    text-decoration: none;\n    white-space: nowrap;\n    transition: color 0.15s;\n    padding-bottom: 0.2rem;\n}\n\n.preview-view-all:hover {\n    color: var(--pink);\n}\n\n/* sidebar will slot in here as a sibling to preview-strip later */\n.preview-body {\n    position: relative;\n    display: flex;\n}\n\n/* right-edge fade hints at more content */\n.preview-body::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    width: 80px;\n    background: linear-gradient(to right, transparent, var(--bg));\n    pointer-events: none;\n    z-index: 1;\n}\n\n.preview-section--alt .preview-body::after {\n    background: linear-gradient(to right, transparent, var(--surface));\n}\n\n.preview-strip {\n    display: flex;\n    gap: 1rem;\n    overflow-x: auto;\n    padding: 0.5rem 2rem 1.5rem;\n    scroll-snap-type: x mandatory;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    flex: 1;\n    min-width: 0;\n}\n\n.preview-strip::-webkit-scrollbar {\n    display: none;\n}\n\n.preview-card {\n    flex: 0 0 clamp(220px, 70vw, 300px);\n    scroll-snap-align: start;\n    border-radius: var(--radius-md);\n    overflow: hidden;\n    box-shadow: 0 8px 28px rgba(74, 37, 18, 0.18), 0 2px 8px rgba(74, 37, 18, 0.10);\n    border: 2.5px solid var(--border);\n}\n\n.preview-img {\n    width: 100%;\n    aspect-ratio: 3 / 4;\n    object-fit: cover;\n    display: block;\n    opacity: 0;\n    transition: opacity 0.45s ease, transform 0.3s ease;\n}\n\n.preview-img.loaded {\n    opacity: 1;\n}\n\n.preview-card:hover .preview-img {\n    transform: scale(1.03);\n}\n\n/* ── Cake Gallery ────────────────────────────────────────────── */\n.gallery-page {\n    opacity: 0;\n    transition: opacity 0.55s ease;\n}\n\n.gallery-page--ready {\n    opacity: 1;\n}\n\n.gallery-hero {\n    background: var(--surface);\n    text-align: center;\n    padding: 5rem 2rem 3.5rem;\n}\n\n.gallery-eyebrow {\n    display: block;\n    font-family: var(--font-script);\n    font-size: clamp(1.4rem, 3vw, 2rem);\n    color: var(--pink);\n    margin-bottom: 0.35rem;\n}\n\n.gallery-heading {\n    font-family: var(--font-serif);\n    font-size: clamp(2rem, 5vw, 3.25rem);\n    font-weight: 600;\n    color: var(--brown-dark);\n    line-height: 1.1;\n    margin-bottom: 1.25rem;\n}\n\n.gallery-rule {\n    width: 48px;\n    height: 2px;\n    background: linear-gradient(90deg, var(--pink), var(--pink-light));\n    border-radius: 2px;\n    margin: 0 auto 1.25rem;\n}\n\n.gallery-subtext {\n    font-size: clamp(0.92rem, 1.8vw, 1.02rem);\n    color: var(--text-muted);\n    max-width: 480px;\n    margin: 0 auto;\n    line-height: 1.75;\n}\n\n.gallery-canvas {\n    position: relative;\n    background: linear-gradient(160deg, var(--bg) 0%, var(--surface) 50%, var(--bg) 100%);\n    overflow: hidden;\n}\n\n.gallery-canvas::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background-image:\n        radial-gradient(circle, rgba(196, 118, 138, 0.75) 4px,   transparent 4px),\n        radial-gradient(circle, rgba(184, 133, 90,  0.55) 3.5px, transparent 3.5px),\n        radial-gradient(circle, rgba(74,  37,  18,  0.20) 3px,   transparent 3px),\n        radial-gradient(circle, rgba(232, 180, 192, 0.80) 3px,   transparent 3px),\n        radial-gradient(circle, rgba(168, 92,  114, 0.50) 2.5px, transparent 2.5px);\n    background-size:\n        311px 293px,\n        257px 271px,\n        383px 367px,\n        199px 211px,\n        431px 419px;\n    background-position:\n        10px 20px,\n        80px 140px,\n        160px 60px,\n        40px 180px,\n        220px 100px;\n    pointer-events: none;\n    z-index: 0;\n}\n\n.gallery-grid {\n    position: relative;\n    z-index: 1;\n    columns: 3 260px;\n    gap: 0.85rem;\n    padding: 2.5rem 2rem;\n    max-width: 1300px;\n    margin: 0 auto;\n}\n\n.gallery-item {\n    break-inside: avoid;\n    margin-bottom: 0.85rem;\n    border-radius: var(--radius-md);\n    overflow: hidden;\n    border: 2.5px solid var(--border);\n    box-shadow: 0 8px 28px rgba(74, 37, 18, 0.18), 0 2px 8px rgba(74, 37, 18, 0.10);\n}\n\n.gallery-img {\n    width: 100%;\n    display: block;\n    opacity: 0;\n    transition: opacity 0.45s ease, transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.gallery-img.loaded {\n    opacity: 1;\n}\n\n.gallery-item:hover .gallery-img {\n    transform: scale(1.025);\n    box-shadow: var(--shadow-lg);\n}\n\n.bakes-section {\n    position: relative;\n    z-index: 1;\n    max-width: 1300px;\n    margin: 0 auto;\n    padding-top: 2rem;\n}\n\n.bakes-section-header {\n    display: flex;\n    align-items: center;\n    gap: 1.25rem;\n    padding: 0 2rem;\n    margin-bottom: 0.5rem;\n}\n\n.bakes-section-label {\n    font-family: var(--font-script);\n    font-size: clamp(1.6rem, 3vw, 2.2rem);\n    color: var(--brown-dark);\n    white-space: nowrap;\n}\n\n.bakes-section-rule {\n    flex: 1;\n    height: 1.5px;\n    background: linear-gradient(90deg, var(--brown-light), transparent);\n    border-radius: 2px;\n    opacity: 0.45;\n}\n\n.gallery-cta-wrap {\n    position: relative;\n    z-index: 1;\n    text-align: center;\n    padding: 1rem 2rem 5rem;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1.25rem;\n}\n\n.gallery-cta-text {\n    font-family: var(--font-script);\n    font-size: clamp(1.4rem, 3vw, 1.9rem);\n    color: var(--brown);\n}\n\n/* ── Responsive ──────────────────────────────────────────────── */\n@media (max-width: 768px) {\n    .order-section {\n        flex-direction: column;\n    }\n\n    .order-section-map {\n        position: static;\n        width: 100%;\n    }\n\n    .hero {\n        min-height: 70vh;\n        padding: 4rem 1.25rem 5rem;\n    }\n\n    .page-content {\n        padding: 1.25rem 0.75rem 2rem;\n    }\n\n    .form-card {\n        padding: 1rem 0.875rem;\n        border-radius: var(--radius-sm);\n        box-shadow: var(--shadow-sm);\n    }\n\n    .form-field {\n        margin-bottom: 1rem;\n    }\n\n    .header {\n        height: 60px;\n        padding: 0 1.25rem;\n    }\n\n    .header-brand {\n        font-size: 1.35rem;\n    }\n\n    .header-nav {\n        gap: 0.75rem;\n    }\n\n    .header-nav-link {\n        display: none;\n    }\n\n    .header-hamburger {\n        display: flex;\n    }\n\n    .section-heading {\n        font-size: 1.2rem;\n        margin-bottom: 1rem;\n    }\n\n    .order-section-map-label {\n        font-size: 0.95rem;\n    }\n\n    .form-radio-group {\n        flex-wrap: wrap;\n    }\n\n    .form-submit {\n        font-size: 0.85rem;\n        padding: 0.7rem 1rem;\n    }\n\n    .process-strip-inner {\n        grid-template-columns: 1fr;\n        gap: 2rem;\n    }\n\n    .process-arrow {\n        display: none;\n    }\n\n    .process-step {\n        padding: 0;\n    }\n\n    .footer-inner {\n        grid-template-columns: 1fr;\n        gap: 2rem;\n    }\n\n    .footer {\n        padding: 2.5rem 1.5rem 0;\n    }\n\n    .story-section {\n        padding: 4rem 1.25rem;\n    }\n\n    .story-inner {\n        flex-direction: column;\n        gap: 2.5rem;\n    }\n\n    .story-photo-wrap {\n        flex: none;\n        width: 100%;\n        max-width: 320px;\n        margin: 0 auto;\n        padding-right: 12px;\n        padding-bottom: 12px;\n    }\n\n    .story-photo-wrap::after {\n        top: 12px;\n        left: 12px;\n    }\n\n    .policies-section {\n        padding: 4rem 1.25rem;\n    }\n\n    .policies-inner {\n        flex-direction: column-reverse;\n        gap: 2.5rem;\n    }\n\n    .policies-photo-wrap {\n        flex: none;\n        width: 100%;\n        max-width: 320px;\n        margin: 0 auto;\n        padding-left: 12px;\n        padding-bottom: 12px;\n    }\n\n    .policies-photo-wrap::after {\n        top: 12px;\n        right: 12px;\n    }\n\n    .gallery-grid {\n        columns: 2 160px;\n        padding: 1.5rem 1rem;\n    }\n\n    .gallery-hero {\n        padding: 3.5rem 1.25rem 2.5rem;\n    }\n}\n\n@media (min-width: 769px) {\n    .preview-strip {\n        justify-content: center;\n    }\n}\n\n/* ── Order Form — item builder & cart ────────────────────────── */\n.form-section-label {\n    font-family: var(--font-serif);\n    font-size: 1.05rem;\n    color: var(--brown-dark);\n    font-weight: 600;\n    margin: 1.5rem 0 0.75rem;\n    padding-bottom: 0.4rem;\n    border-bottom: 1.5px solid var(--surface-alt);\n}\n\n.form-required { color: var(--pink-dark); }\n\n.form-checkbox-row {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    font-size: 0.9rem;\n    color: var(--brown);\n    cursor: pointer;\n    margin-bottom: 0.75rem;\n}\n\n.form-checkbox-row input[type=\"checkbox\"] {\n    accent-color: var(--pink);\n    width: 15px;\n    height: 15px;\n    cursor: pointer;\n    flex-shrink: 0;\n}\n\n.item-builder {\n    background: var(--surface);\n    border: 1.5px solid var(--border);\n    border-radius: var(--radius-sm);\n    padding: 1.25rem;\n    margin-bottom: 1rem;\n}\n\n.item-builder-note {\n    font-size: 0.875rem;\n    color: var(--text-muted);\n    font-style: italic;\n    margin-bottom: 0.75rem;\n    line-height: 1.55;\n}\n\n.item-builder-price {\n    font-size: 0.875rem;\n    color: var(--brown);\n    font-weight: 600;\n    margin-bottom: 0.5rem;\n}\n\n.item-builder-actions {\n    display: flex;\n    gap: 0.5rem;\n    margin-top: 0.5rem;\n}\n\n.cart-item {\n    background: var(--bg);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-sm);\n    padding: 0.75rem;\n    margin-bottom: 0.5rem;\n}\n\n.cart-item-header {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-bottom: 0.35rem;\n}\n\n.cart-item-type {\n    font-weight: 700;\n    font-size: 0.9rem;\n    color: var(--brown-dark);\n    flex: 1;\n}\n\n.cart-item-index {\n    font-size: 0.78rem;\n    color: var(--text-muted);\n}\n\n.cart-item-details {\n    list-style: none;\n    font-size: 0.83rem;\n    color: var(--text-muted);\n    line-height: 1.6;\n    padding-left: 0;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.2rem 0.75rem;\n}\n\n.btn-add-item {\n    width: 100%;\n    padding: 0.6rem;\n    background: transparent;\n    border: 1.5px dashed var(--border);\n    border-radius: var(--radius-sm);\n    cursor: pointer;\n    font-family: var(--font-sans);\n    font-size: 0.88rem;\n    font-weight: 600;\n    color: var(--brown);\n    letter-spacing: 0.04em;\n    transition: border-color 0.15s, color 0.15s, background 0.15s;\n    margin-bottom: 0.25rem;\n}\n\n.btn-add-item:hover {\n    border-color: var(--pink);\n    color: var(--pink-dark);\n    background: rgba(196, 118, 138, 0.04);\n}\n\n.fixed-items-list {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    margin-bottom: 0.75rem;\n}\n\n.fixed-item-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 1rem;\n    background: var(--bg);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-sm);\n    padding: 0.65rem 0.85rem;\n}\n\n.fixed-item-info {\n    display: flex;\n    flex-direction: column;\n    gap: 0.15rem;\n    flex: 1;\n    min-width: 0;\n}\n\n.fixed-item-name { font-weight: 600; font-size: 0.9rem; color: var(--black); }\n.fixed-item-meta { font-size: 0.8rem; color: var(--brown); }\n.fixed-item-desc { font-size: 0.8rem; color: var(--text-muted); font-style: italic; }\n\n.fixed-item-qty {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    flex-shrink: 0;\n}\n\n.qty-btn {\n    width: 28px;\n    height: 28px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background: var(--surface);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-sm);\n    cursor: pointer;\n    font-size: 1rem;\n    line-height: 1;\n    color: var(--brown);\n    font-family: var(--font-sans);\n    transition: background 0.1s;\n}\n\n.qty-btn:hover { background: var(--surface-alt); }\n\n.qty-value {\n    font-size: 0.9rem;\n    font-weight: 700;\n    color: var(--black);\n    min-width: 1.5rem;\n    text-align: center;\n}\n\n/* ── Order Card — items section ──────────────────────────────── */\n.order-card-items {\n    margin: 0.5rem 0;\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n}\n\n.order-card-item {\n    background: #fff;\n    border: 1px solid var(--border);\n    border-radius: var(--radius-sm);\n    padding: 0.55rem 0.7rem;\n}\n\n.order-card-item-header {\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n    margin-bottom: 0.25rem;\n    flex-wrap: wrap;\n}\n\n.order-card-item-type {\n    font-weight: 700;\n    font-size: 0.855rem;\n    color: var(--brown-dark);\n}\n\n.order-card-item-size {\n    font-size: 0.79rem;\n    color: var(--brown);\n}\n\n.order-card-item-qty {\n    font-size: 0.79rem;\n    color: var(--text-muted);\n}\n\n.order-card-item-details {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.15rem 0.6rem;\n    font-size: 0.79rem;\n    color: var(--text-muted);\n    line-height: 1.5;\n}\n\n.order-card-fixed-items {\n    border-top: 1px solid var(--border);\n    padding-top: 0.35rem;\n    margin-top: 0.1rem;\n}\n\n.order-card-unit {\n    font-weight: normal;\n    color: var(--text-muted);\n}\n\n.order-card-cake-prices {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    margin-bottom: 0.5rem;\n}\n\n.order-card-cake-price-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 0.75rem;\n}\n\n.order-card-cake-price-label {\n    font-size: 0.85rem;\n    font-weight: 600;\n    color: var(--brown-dark);\n    flex-shrink: 0;\n}\n\n.order-card-cake-price-wrap {\n    display: flex;\n    align-items: center;\n    gap: 0.2rem;\n}\n\n.order-card-cake-price-symbol {\n    font-size: 0.875rem;\n    color: var(--text-muted);\n}\n\n.order-card-deposit-summary {\n    background: var(--surface);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-sm);\n    padding: 0.5rem 0.75rem;\n    margin-bottom: 0.5rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.25rem;\n}\n\n.order-card-deposit-row {\n    display: flex;\n    justify-content: space-between;\n    font-size: 0.85rem;\n    color: var(--brown);\n}\n\n.order-card-deposit-row--highlight {\n    font-weight: 700;\n    color: var(--brown-dark);\n    border-top: 1px solid var(--border);\n    padding-top: 0.25rem;\n    margin-top: 0.1rem;\n}\n\n/* ── Options Manager — new panel elements ────────────────────── */\n.options-select {\n    width: 100%;\n    padding: 0.4rem 0.65rem;\n    border: 1.5px solid var(--border);\n    border-radius: var(--radius-sm);\n    background: var(--bg);\n    color: var(--black);\n    font-family: var(--font-sans);\n    font-size: 0.875rem;\n    outline: none;\n}\n\n.options-select:focus { border-color: var(--border-focus); }\n\n.options-gf-tag {\n    font-size: 0.68rem;\n    font-weight: 700;\n    background: #d1fae5;\n    color: #065f46;\n    padding: 0.1rem 0.35rem;\n    border-radius: 4px;\n    letter-spacing: 0.04em;\n    flex-shrink: 0;\n}\n\n.options-gf-checkbox {\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n    font-size: 0.82rem;\n    color: var(--brown);\n    cursor: pointer;\n}\n\n.options-gf-checkbox input[type=\"checkbox\"] {\n    accent-color: var(--pink);\n    width: 14px;\n    height: 14px;\n    cursor: pointer;\n}\n\n.options-item-meta {\n    font-size: 0.78rem;\n    color: var(--text-muted);\n    flex-shrink: 0;\n}\n\n.options-add-form {\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n}\n\n.options-add-form .form-input {\n    font-size: 0.875rem;\n    padding: 0.4rem 0.65rem;\n}\n\n/* ── Order Summary (customer form) ───────────────────────────── */\n.order-summary {\n    background: var(--surface);\n    border: 1px solid var(--border);\n    border-radius: var(--radius-sm);\n    padding: 0.85rem 1rem;\n    margin-bottom: 1.25rem;\n    display: flex;\n    flex-direction: column;\n    gap: 0.3rem;\n}\n\n.order-summary-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n    font-size: 0.875rem;\n    color: var(--black);\n}\n\n.order-summary-total {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n    font-size: 0.92rem;\n    font-weight: 700;\n    color: var(--brown-dark);\n    border-top: 1.5px solid var(--border);\n    padding-top: 0.4rem;\n    margin-top: 0.2rem;\n}\n\n.order-summary-tbd {\n    font-style: italic;\n    font-weight: 400;\n    color: var(--text-muted);\n    font-size: 0.83rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
